import {
  FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS,
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  DIFERENCE_MINUTES,
  HEADER_TAB_SETUP,
} from "../../functions/funtion";
import {
  ENCRYPT_STORAGE_SESSION,
  ENCRYPT_STORAGE,
  WebWidth,
  WebLeft,
  CSP,
} from "../../config/config";
import {
  PT_FILTER_OUTLETS_PRODUCTS,
  PT_MASTERCATEGORY,
  PT_PRODUCT,
  PT_HOME,
} from "../../routes/stack/paths/pt-home";
import {
  STORE_FAVOURITE_MERCHANT_LIST,
  STORE_PRODUCT_LIST,
  STORE_PROMO_PRODUCT_LIST,
  STORE_DineType,
  ENTRY_MODE,
  TABLE_NO,
  STORE_INVALID_QR,
} from "../../database/store-names";
import {
  GET_CART_SELECT_MERCHATS_ZONE,
  GET_SET_STORED_DATA,
  GET_CART,
} from "../../database/get-stored-data";
import {
  set_dto_selected_final_merchant_or_product,
  set_dto_selected_merchant_or_product,
  set_dto_MobileAppCategory,
  set_dto_Merchant,
} from "../../classes/dto-setters/dto-setter";
import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../classes/dto-selected-merchant-or-product";
import {
  Api_DrawAnalyticalPath,
  api_DaitonnAnalytical,
} from "../../connection/api/api-Machine-Learning";
import { api_LoadProductListToMobileAppForAnMID } from "../../connection/api/api-product-list";
import { api_CategoryPageLoadGroceryCategory } from "../../connection/api/api-grocery-category";
import { api_UpdateIsFavouriteForMerchant } from "../../connection/api/api-home";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { dto_MobileAppCategory } from "../../classes/dto-mobile-app-category";
import { SET_STORE_DINE_TYPE } from "../../database/store-data";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_Merchant } from "../../classes/dto-merchant";
import { dto_common } from "../../classes/dto-common";
import {
  getQrTableNumber,
  resolveDineTypeSelection,
} from "../../functions/dine-type";
import { F_Fammily } from "../../util/config-fonts";
import { isMobile } from "react-device-detect";
import { Colors } from "../../util/colors";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import SummaryCart from "../../components/render-drawer-summary-cart/render-drawer-summary-cart";
import PlaceHolder from "./components/product-list-place-holder/product-list-place-holder";
import { ToastMessage } from "../../components/toast-notification/toast";
import Category from "./components/product-lisit-category/product_list_category";
import ItemView from "./components/product-list-item/product-list-item";
import { createPortal } from "react-dom";
import React from "react";
import "../../styles/css/pg-product-list.css";
import "../../styles/css/fixedbutton.css";
import "../../styles/css/animate.css";
var $ = require("jquery");
const cloneDeep = require("lodash.clonedeep");
const qrProductListMemoryCache = new Map();

export default class ProductList extends React.Component {
  constructor(props) {
    super(props);
    const invalidQrValue = ENCRYPT_STORAGE.getItem(STORE_INVALID_QR);
    const invalidQr = invalidQrValue === true || invalidQrValue === "true";

    this.state = {
      CateList: [],
      PrdList: [],
      inMemoryProducts: [],
      isLoading: true,
      displayMessage: false,
      desc: "",
      DrawerIsOpen: false,
      PID: 0,
      LineID: 0,
      AddonLineID: 0,
      Category: 0,
      FromPage: 0,
      LocalCart: [],
      IsSummaryCart: false,
      ActiveIndex: 0,
      PaddingLeft: "14%",
      DelPaddingLeft: "17%",
      MainTopMargin: "0px",
      iconDisplay: "block",
      deliveryDisabled: false,
      takeawayDisabled: false,
      MerchantData: [],
      filterText: "",
      IsFavourite: false,
      SwitchCategory: false,
      CategoryList: [],
      showDropdown: false,
      showSortDropDown: false,
      activeCategoryId: null,
      isFilterOpen: false,
      invalidQr,
    };
    this.safariTouchFixTimer = null;
    this.searchInputRef = React.createRef();
    this.searchFocusTimer = null;
    this.latestMerchantData = null;
  }

  async componentDidMount() {
    if (this.shouldListenToCartUpdates()) {
      window.addEventListener("cartUpdated", this.syncLocalCart);
    }
    document
      .querySelectorAll(".shadow-overlay")
      .forEach((node) => node.remove());
    let HeaderCommonId = document.getElementById("DivHeaderHome");
    if (CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF") {
      HeaderCommonId.style.display = "none";
    }
    if (CSP === "MK") {
      this.setState({ SwitchCategory: false });
      localStorage.setItem("isAllCat", false);
    }
    if (CSP === "DT") {
      if (dto_selected_merchant_or_product.Merchant === "MKB Supermarket") {
        localStorage.setItem("isAllCat", false);
      } else {
        dto_selected_merchant_or_product.CATID = 0;
      }
    }

    if (this.state.invalidQr) {
      let HeaderCommonId = document.getElementById("DivHeaderHome");
      if (HeaderCommonId) {
        HeaderCommonId.style.display = "none";
      }
      await HEADER_TAB_SETUP({
        HeaderTabName: "Invalid QR",
        FnGoBackScreen: () => {},
        HeaderNavigatorMenuDisplay: false,
        HeaderBackButtonDisplay: false,
        FnHeaderNavigatorMenu: () => {},
      });
      this.setState({
        CateList: [],
        PrdList: [],
        inMemoryProducts: [],
        isLoading: false,
        displayMessage: true,
      });
      return;
    }

    await GET_SET_STORED_DATA();
    if (this.props.params.navPage === "cart") {
      const cartMerchant = await GET_CART_SELECT_MERCHATS_ZONE();
      if (cartMerchant) {
        await set_dto_Merchant(cartMerchant);
        await set_dto_selected_final_merchant_or_product(cartMerchant);
        await set_dto_selected_merchant_or_product(cartMerchant);
      }
    }
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length:
          CSP === "DT" && ENCRYPT_STORAGE.getItem(ENTRY_MODE) === "QR"
            ? 40
            : 20,
        string: this.state.invalidQr
          ? "Invalid QR"
          : dto_selected_merchant_or_product.Merchant,
      }),
      FnGoBackScreen: () => {
        const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
        const blockHomeNav = CSP === "DT" && entryMode === "QR";
        const isInlinePromoMode =
          (CSP === "MK" ||
            (CSP === "DT" &&
              dto_selected_merchant_or_product.Merchant ===
                "MKB Supermarket")) &&
          Number(dto_selected_merchant_or_product.CATID) === 1;

        if (isInlinePromoMode) {
          if (blockHomeNav) {
            return;
          }
          this.props.navigate(PT_HOME);
          return;
        }

        if (
          dto_selected_merchant_or_product.MT === "RS" &&
          dto_selected_final_merchant_or_product.CSP !== "MK"
        ) {
          if (this.props.params.navPage === "home-filter") {
            this.props.navigate(
              PT_FILTER_OUTLETS_PRODUCTS.replace(":frmpath", "home"),
            );
          } else if (this.props.params.navPage === "home") {
            if (blockHomeNav) {
              return;
            }
            this.props.navigate(PT_HOME);
          } else {
            if (CSP === "MK") {
              this.props.navigate(PT_MASTERCATEGORY);
            } else {
              if (blockHomeNav) {
                return;
              }
              this.props.navigate(PT_HOME);
            }
          }
        } else {
          if (this.props.params.navPage === "shome") {
            if (blockHomeNav) {
              return;
            }
            this.props.navigate(PT_HOME);
          } else {
            this.props.navigate(PT_MASTERCATEGORY);
          }
        }
      },
      HeaderNavigatorMenuDisplay: !this.state.invalidQr,
      HeaderBackButtonDisplay:
        !this.state.invalidQr &&
        !(CSP === "DT" && ENCRYPT_STORAGE.getItem(ENTRY_MODE) === "QR"),
      FnHeaderNavigatorMenu: () => {
        this.openFilterBox();
      },
    });
    if (this.shouldLoadGroceryCategories()) {
      await this.LoadMasterCategory();
    }
    await this.LoadProduct();

    await api_DaitonnAnalytical();

    await this.Setdinetype();
    if (CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF") {
      this.checkIsFavourite();
    }
  }

  componentWillUnmount() {
    if (this.shouldListenToCartUpdates()) {
      window.removeEventListener("cartUpdated", this.syncLocalCart);
    }
    const element = this.handleScroll
      ? isMobile
        ? document.querySelector(".body-container")
        : document.querySelector(".WindowDevice")
      : null;
    if (element && this.handleScroll) {
      element.removeEventListener("scroll", this.handleScroll);
    }
    if (this.safariTouchFixTimer) {
      clearTimeout(this.safariTouchFixTimer);
      this.safariTouchFixTimer = null;
    }
    if (this.searchFocusTimer) {
      clearTimeout(this.searchFocusTimer);
      this.searchFocusTimer = null;
    }
  }

  safariTouchFix = () => {
    const body = document.body;
    if (!body) {
      return;
    }
    body.style.pointerEvents = "auto";
    if (this.safariTouchFixTimer) {
      clearTimeout(this.safariTouchFixTimer);
    }
    requestAnimationFrame(() => {
      body.style.pointerEvents = "auto";
    });
    this.safariTouchFixTimer = setTimeout(() => {
      body.style.pointerEvents = "auto";
      this.safariTouchFixTimer = null;
    }, 400);
  };

  getScrollContainer = () => {
    return (
      document.querySelector(".body-container") ||
      document.querySelector(".WindowDevice") ||
      document.scrollingElement ||
      document.documentElement ||
      document.body
    );
  };

  getScrollTargets = () => {
    const uniqueTargets = new Set();
    [
      document.querySelector(".body-container"),
      document.querySelector(".WindowDevice"),
      document.scrollingElement,
      document.documentElement,
      document.body,
    ]
      .filter(Boolean)
      .forEach((node) => uniqueTargets.add(node));
    return Array.from(uniqueTargets);
  };

  getElementTopWithinContainer = (target, container) => {
    if (!target || !container) {
      return 0;
    }

    let currentNode = target;
    let top = 0;

    while (currentNode && currentNode !== container) {
      top += currentNode.offsetTop || 0;
      currentNode = currentNode.offsetParent;
    }

    if (currentNode === container) {
      return top;
    }

    const containerRect = container.getBoundingClientRect
      ? container.getBoundingClientRect()
      : { top: 0 };
    const targetRect = target.getBoundingClientRect();
    return (container.scrollTop || 0) + (targetRect.top - containerRect.top);
  };

  setStateAsync = (stateUpdate) =>
    new Promise((resolve) => {
      this.setState(stateUpdate, resolve);
    });

  shouldListenToCartUpdates = () => CSP === "MK" || CSP === "DT";

  syncLocalCart = async (event) => {
    if (!this.shouldListenToCartUpdates()) {
      return;
    }

    const eventCart = event?.detail?.cart;
    if (Array.isArray(eventCart)) {
      this.setState({ LocalCart: [...eventCart] });
      return;
    }

    let Localcart = await GET_CART();
    if (Localcart === undefined) {
      Localcart = [];
    }

    this.setState({ LocalCart: Localcart });
  };

  getProductDetailNavigatePage = () => "product-list";

  waitForNextPaint = () =>
    new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });

  getQrProductCacheKey = () => {
    const qrTableNo = getQrTableNumber(
      CSP === "DT" ? ENCRYPT_STORAGE.getItem(ENTRY_MODE) : "",
      ENCRYPT_STORAGE.getItem(TABLE_NO),
    );

    if (CSP !== "DT" || qrTableNo === "") {
      return "";
    }

    return [
      String(dto_selected_merchant_or_product.MID || ""),
      String(dto_selected_merchant_or_product.CATID || ""),
      String(qrTableNo),
      String(this.props.params?.navPage || ""),
    ].join("::");
  };

  getCachedQrProductList = () => {
    const cacheKey = this.getQrProductCacheKey();
    if (cacheKey === "") {
      return null;
    }

    return qrProductListMemoryCache.get(cacheKey) || null;
  };

  setCachedQrProductList = (cacheValue) => {
    const cacheKey = this.getQrProductCacheKey();
    if (cacheKey === "") {
      return;
    }

    qrProductListMemoryCache.set(cacheKey, cacheValue);
  };

  getCategoryProducts = (category) => {
    try {
      return JSON.parse(category?.dtoProductSessionList || "[]");
    } catch (error) {
      return [];
    }
  };

  shouldLoadGroceryCategories = () =>
    dto_selected_merchant_or_product.MT === "GR" || CSP === "MK";

  buildCategoryListFromProducts = (products = []) => {
    const seenKeys = new Set();

    return (Array.isArray(products) ? products : []).reduce((list, item) => {
      const catId = item?.CATID;
      const categoryName = item?.Category;
      const dedupeKey = `${String(catId || "")}::${String(
        categoryName || "",
      ).trim()}`;

      if (seenKeys.has(dedupeKey)) {
        return list;
      }

      seenKeys.add(dedupeKey);
      list.push({
        CATID: catId,
        Category: categoryName,
        ListType: item?.ListType ?? 0,
      });
      return list;
    }, []);
  };

  hasValidMerchantData = (merchantData) => {
    if (!merchantData || typeof merchantData !== "object") {
      return false;
    }

    const merchantId = String(merchantData.MID ?? "").trim();
    return (
      merchantId !== "" && merchantId !== "undefined" && merchantId !== "null"
    );
  };

  resolveMerchantData = (...merchantCandidates) => {
    const candidates = [
      ...merchantCandidates,
      this.latestMerchantData,
      this.state.MerchantData,
      dto_selected_final_merchant_or_product,
      dto_selected_merchant_or_product,
      dto_Merchant,
    ];

    return (
      candidates.find((candidate) => this.hasValidMerchantData(candidate)) ||
      null
    );
  };

  setSelectedCategoryLabel = (categoryName = "") => {
    const selectedCat = document.getElementById("SelectedCat");
    if (!selectedCat) {
      return;
    }
    selectedCat.innerText =
      categoryName.length > 25
        ? categoryName.slice(0, 25) + "..."
        : categoryName;
  };

  getVisibleCategoryEntries = () => {
    const sourceCategories =
      this.state.PrdList && this.state.PrdList.length > 0
        ? this.state.PrdList
        : this.state.CategoryList;

    const normalizedMasterCategories = this.state.CategoryList || [];
    const seenKeys = new Set();

    return sourceCategories.reduce((list, category) => {
      const productList = this.getCategoryProducts(category);
      if (productList.length === 0) {
        return list;
      }

      const categoryName = String(category.Category || "").trim();
      const normalizedCategoryName = categoryName.toUpperCase();
      const matchedMasterCategory = normalizedMasterCategories.find(
        (item) =>
          String(item.CATID) === String(category.CATID) ||
          String(item.Category || "")
            .trim()
            .toUpperCase() === normalizedCategoryName,
      );

      const resolvedCategory = matchedMasterCategory || category;
      const dedupeKey =
        String(resolvedCategory.CATID || "") + "::" + normalizedCategoryName;

      if (seenKeys.has(dedupeKey)) {
        return list;
      }

      seenKeys.add(dedupeKey);
      list.push({
        ...resolvedCategory,
        CATID: resolvedCategory.CATID ?? category.CATID,
        Category: resolvedCategory.Category || category.Category,
        ListType: resolvedCategory.ListType ?? category.ListType,
      });
      return list;
    }, []);
  };

  getSelectableCategoryEntries = () => {
    if (CSP === "MK" && this.state.CategoryList.length > 0) {
      return this.state.CategoryList;
    }

    return this.getVisibleCategoryEntries();
  };

  shouldLoadProductsForCategorySelect = (cate) => {
    if (CSP !== "MK") {
      return false;
    }

    const targetCATID = this.getTargetCategoryId(cate?.CATID);
    return !this.findCategorySection(targetCATID, cate?.Category || "");
  };

  syncHorizontalCategory = (categoryId) => {
    const hContainer = document.getElementById("horizontalCateSection");
    if (!hContainer || categoryId === undefined || categoryId === null) {
      return;
    }

    const activeBtn = hContainer.querySelector(
      `[data-catid="${String(categoryId)}"]`,
    );

    if (!activeBtn) {
      return;
    }

    const left =
      activeBtn.offsetLeft -
      hContainer.clientWidth / 2 +
      activeBtn.clientWidth / 2;

    hContainer.scrollTo({
      left: Math.max(0, left),
      behavior: "smooth",
    });
  };

  resolveCategoryId = (categoryId, categoryName = "") => {
    const normalizedCategoryId = String(categoryId);
    const visibleCategories = this.getVisibleCategoryEntries();
    const directMatch = visibleCategories.find(
      (item) => String(item.CATID) === normalizedCategoryId,
    );
    if (directMatch) {
      return String(directMatch.CATID);
    }

    const masterMatch = this.state.CategoryList.find(
      (item) => String(item.CATID) === normalizedCategoryId,
    );
    if (masterMatch) {
      return String(masterMatch.CATID);
    }

    const normalizedCategoryName = String(categoryName).trim().toUpperCase();
    if (!normalizedCategoryName) {
      return normalizedCategoryId;
    }

    const nameMatch = visibleCategories.find(
      (item) =>
        String(item.Category || "")
          .trim()
          .toUpperCase() === normalizedCategoryName,
    );

    return nameMatch ? String(nameMatch.CATID) : normalizedCategoryId;
  };

  syncActiveCategory = (categoryId, categoryName = "") => {
    if (categoryName) {
      this.setSelectedCategoryLabel(categoryName);
    }

    const nextCategoryId = this.resolveCategoryId(categoryId, categoryName);
    if (this.state.activeCategoryId !== nextCategoryId) {
      this.setState({ activeCategoryId: nextCategoryId }, () => {
        this.syncHorizontalCategory(nextCategoryId);
      });
      return;
    }

    this.syncHorizontalCategory(nextCategoryId);
  };

  getCategorySectionId = (categoryId) => `${categoryId}SECTIONS`;

  findCategorySection = (categoryId, categoryName = "") => {
    const targetId = this.getCategorySectionId(categoryId);
    const targetById = document.getElementById(targetId);
    if (targetById) {
      return targetById;
    }

    const normalizedCategoryName = String(categoryName).trim().toUpperCase();
    if (!normalizedCategoryName) {
      return null;
    }

    const sections = Array.from(document.getElementsByClassName("ItemList"));
    return (
      sections.find((section) => {
        const heading = section.querySelector("h1");
        return (
          heading &&
          String(heading.innerText || heading.textContent || "")
            .trim()
            .toUpperCase() === normalizedCategoryName
        );
      }) || null
    );
  };

  getTargetCategoryId = (categoryId) => {
    if (
      Number(categoryId) === 0 &&
      this.state.CategoryList &&
      this.state.CategoryList.length > 1
    ) {
      return this.state.CategoryList[1].CATID;
    }

    return categoryId;
  };

  handleCategorySelect = async (
    cate,
    { closeDropdown = false, offset = 105, shouldLoadProducts = false } = {},
  ) => {
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const isPosQr = CSP === "DT" && entryMode === "QR";

    if (closeDropdown) {
      this.setState({ showDropdown: false }, () => {
        this.safariTouchFix();
      });
    }

    dto_selected_merchant_or_product.CATID = cate.CATID;
    dto_MobileAppCategory.ListType = cate.ListType;

    if (cate.CATID === 0) {
      localStorage.setItem("isAllCat", true);
      dto_selected_merchant_or_product.CATID = this.getTargetCategoryId(
        cate.CATID,
      );
      if (!isPosQr && shouldLoadProducts) {
        this.setState({ PrdList: [] });
      }
    } else {
      localStorage.setItem("isAllCat", "false");
      if (!isPosQr && shouldLoadProducts) {
        this.setState({ PrdList: [] });
      }
    }

    if (shouldLoadProducts) {
      await this.loadSubProduct();
      this.safariTouchFix();
    }

    const targetCATID = this.getTargetCategoryId(cate.CATID);
    const categoryText = cate.Category || "";
    const truncatedText =
      categoryText.length > 25
        ? categoryText.slice(0, 25) + "..."
        : categoryText;

    this.syncActiveCategory(targetCATID, truncatedText);
    await this.waitForNextPaint();

    setTimeout(() => {
      this.scrollToCategorySection(targetCATID, categoryText, offset);
    }, 80);
  };

  scrollToCategorySection = (
    categoryId,
    categoryName = "",
    offset = 105,
    retries = 12,
  ) => {
    const attemptScroll = (remainingRetries) => {
      const target = this.findCategorySection(categoryId, categoryName);
      if (target) {
        this.scrollToTarget(target.id, offset);
        return;
      }

      if (remainingRetries <= 0) {
        return;
      }

      setTimeout(() => {
        requestAnimationFrame(() => {
          attemptScroll(remainingRetries - 1);
        });
      }, 50);
    };

    attemptScroll(retries);
  };

  scrollToTarget = (targetId, offset = 105) => {
    const target = document.getElementById(targetId);
    if (!target) return;

    const targetTop = Math.max(0, (target.offsetTop || 0) - offset);

    window.scrollTo({
      top: targetTop,
      behavior: "smooth",
    });

    this.getScrollTargets().forEach((container) => {
      const isRootContainer =
        container === document.body ||
        container === document.documentElement ||
        container === document.scrollingElement;

      if (isRootContainer) {
        return;
      }

      const nextTop = Math.max(
        0,
        this.getElementTopWithinContainer(target, container) - offset,
      );

      if (typeof container.scrollTo === "function") {
        container.scrollTo({
          top: nextTop,
          behavior: "smooth",
        });
        return;
      }

      container.scrollTop = nextTop;
    });

    if (typeof $ === "function") {
      $("html, body").stop(true).animate({ scrollTop: targetTop }, 300);
      $(".WindowDevice, .body-container")
        .stop(true)
        .animate({ scrollTop: targetTop }, 300);
    }
  };

  getTotalPrice() {
    const total = this.state.LocalCart.reduce(
      (sum, item) => sum + item.Qty * item.UP,
      0,
    );
    const formattedTotal = total.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${dto_StartupPageLoadInfo.Currency} ${formattedTotal}`;
  }

  focusSearchInput = () => {
    if (this.searchFocusTimer) {
      clearTimeout(this.searchFocusTimer);
    }

    this.searchFocusTimer = setTimeout(() => {
      const input = this.searchInputRef.current;
      if (input) {
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
      }
      this.searchFocusTimer = null;
    }, 50);
  };

  openFilterBox = () => {
    this.setState(
      {
        isFilterOpen: true,
        showDropdown: false,
        showSortDropDown: false,
      },
      this.focusSearchInput,
    );
  };

  closeFilterBox = ({ reset = true } = {}) => {
    const nextState = {
      isFilterOpen: false,
      displayMessage: false,
    };

    if (reset) {
      nextState.filterText = "";
      nextState.CateList = this.state.inMemoryProducts;
      nextState.PrdList = this.state.inMemoryProducts;
    }

    this.setState(nextState, () => {
      const input = this.searchInputRef.current;
      if (input) {
        input.blur();
      }
    });
  };

  render() {
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const qrTableNo = getQrTableNumber(
      CSP === "DT" ? entryMode : "",
      ENCRYPT_STORAGE.getItem(TABLE_NO),
    );
    const isQrEntryMode = qrTableNo !== "";
    const selectableCategoryEntries = this.getSelectableCategoryEntries();
    const categoryList = this.state.CateList || [];
    const productCategoryList = this.state.PrdList || [];
    const isInlinePromoMode =
      (CSP === "MK" ||
        (CSP === "DT" &&
          dto_selected_merchant_or_product.Merchant === "MKB Supermarket")) &&
      Number(dto_selected_merchant_or_product.CATID) === 1 &&
      productCategoryList.some(
        (item) =>
          String(item?.Category || "")
            .trim()
            .toUpperCase() === "OFFER",
      );
    return (
      <div
        id="OnScrollProdcutList"
        style={{
          marginBottom: 55,
          WebkitTextSizeAdjust: "100%",
          textSizeAdjust: "100%",
          marginTop:
            CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
              ? "44px"
              : this.state.MainTopMargin,
        }}
      >
        <div
          id="NewFilterationTextBox"
          className="fadeInBottom cssanimation"
          style={{
            display: this.state.isFilterOpen ? "block" : "none",
            position: "fixed",
            paddingTop: "5px",
            top: 0,
            left: isMobile ? 0 : WebLeft,
            height: 50,
            width: isMobile ? "100%" : WebWidth,
            zIndex: 1800,
            backgroundColor: "white",
          }}
        >
          <div style={{ display: "flex" }}>
            {/* textbox */}
            <input
              className="productlistFilterTextBox"
              type="text"
              style={{
                width: "90%",
                height: 50,
                border: "none",
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                paddingLeft: "8px",
              }}
              value={this.state.filterText}
              placeholder="Fillter Items"
              id="InputproductlistFilterTextBox"
              ref={this.searchInputRef}
              onChange={this.handleFilterChange}
            />

            {/* circle close */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderRight: "1px solid gray",
                color: "#a1a1a1",
                backgroundColor: "#fff",
                padding: "7px",
              }}
              id="btnproductlistFilterTextBoxclear"
              onClick={this.resetFilter}
            >
              <i className="bi bi-x-circle-fill" />
            </button>

            {/* cancel */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                backgroundColor: "white",
                fontFamily: F_Fammily.Medium,
                fontWeight: "600",
              }}
              id="btnproductlistFilterTextBoxClsoe"
              onClick={this.handleCancelClick}
            >
              Cancel
            </button>
          </div>
        </div>

        {this.state.isLoading ? (
          <PlaceHolder />
        ) : (
          <>
            <div
              style={{
                display:
                  CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
                    ? "none"
                    : "block",
              }}
            >
              {/* Parent div with relative positioning */}
              <div style={{ position: "relative" }}>
                <img
                  src={this.state.MerchantData.IL}
                  style={{ width: "100%", height: 180, objectFit: "cover" }}
                  alt={this.state.MerchantData.IL}
                />

                {/* Back Icon */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "5px",
                    fontSize: 24,
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    padding: "5px",
                    borderRadius: "30px",
                    display:
                      CSP === "DT" && entryMode === "QR"
                        ? "none"
                        : this.state.iconDisplay,
                  }}
                  onClick={() => {
                    const blockHomeNav = CSP === "DT" && entryMode === "QR";
                    if (blockHomeNav) {
                      return;
                    } else if (dto_selected_merchant_or_product.MT === "RS") {
                      if (this.props.params.navPage === "home-filter") {
                        this.props.navigate(
                          PT_FILTER_OUTLETS_PRODUCTS.replace(
                            ":frmpath",
                            "home",
                          ),
                        );
                      } else {
                        this.props.navigate(PT_HOME);
                      }
                    } else {
                      this.props.navigate(PT_MASTERCATEGORY);
                    }
                  }}
                >
                  <i className="bi bi-arrow-left" />
                </div>

                {/* Search Icon */}
                <div
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    top: "10px",
                    right: "5px",
                    fontSize: 24,
                    color: "white",
                    padding: "5px",
                    borderRadius: "30px",
                    display: this.state.iconDisplay,
                  }}
                  id="HeaderNavigatorBoostrapIcon"
                  onClick={this.openFilterBox}
                >
                  <i className="bi bi-search" />
                </div>

                {/* Is Favourite */}
                {dto_Customer.CSID !== 0 && CSP === "AV" ? (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "5px",
                      width: "fit-content",
                      backgroundColor: this.state.IsFavourite
                        ? "rgba(255, 255, 255, 0.25)"
                        : null,
                      color: this.state.IsFavourite ? "red" : "lightgrey",
                      padding: "6px",
                      borderRadius: "5px",
                    }}
                  >
                    <i
                      className="bi bi-heart-fill"
                      onClick={(event) => this.handleHeartClick(event)}
                    />
                  </div>
                ) : null}
              </div>

              {/* Merchant Info Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 5px",
                }}
              >
                <div
                  style={{
                    // fontSize: 14,
                    fontWeight: "bold",
                    display:
                      (CSP === "DT" || CSP === "MK") && entryMode !== "QR"
                        ? "none"
                        : "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-shop" style={{ paddingRight: "8px" }} />
                  {this.state.MerchantData.Merchant}
                </div>

                <div
                  style={{
                    display:
                      this.state.MerchantData.AR > 0 && entryMode !== "QR"
                        ? "flex"
                        : "none",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-hand-thumbs-up-fill" />
                  <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                    {" "}
                    {this.state.MerchantData.AR}%
                  </span>
                </div>

                <div
                  style={{
                    display:
                      CSP === "DT" &&
                      this.state.MerchantData.MS !== "OPEN" &&
                      entryMode === "QR"
                        ? "flex"
                        : "none",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      marginLeft: "5px",
                      fontWeight: "bold",
                      color: "red",
                    }}
                  >
                    {this.state.MerchantData.MS}
                  </span>
                </div>
              </div>

              <div
                className="commonnWrap"
                style={{
                  marginLeft:
                    entryMode === "QR" ? "2%" : CSP !== "AV" ? "11%" : "",
                  display:
                    CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
                      ? "none"
                      : "flex",
                  paddingLeft:
                    entryMode === "QR"
                      ? 0
                      : CSP !== "MK" &&
                          dto_selected_merchant_or_product.MT !== "AF"
                        ? "10px"
                        : 0,
                }}
              >
                {/* catList */}
                <div>
                  <i
                    className="bi bi-list"
                    style={{
                      fontSize: 22,
                      position: "absolute",
                      left: 5,
                      padding: "6px 8px",
                      borderRadius: "18px",
                      color: "white",
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                      margin: "5px 8px 10px 8px",
                      display:
                        (CSP === "DT" || CSP === "MK") && entryMode !== "QR"
                          ? "block"
                          : "none",
                    }}
                    onClick={() => {
                      this.setState({
                        showDropdown: !this.state.showDropdown,
                      });
                    }}
                  />
                </div>

                {isQrEntryMode && qrTableNo > 0 ? (
                  <div
                    className="DTSwitchBox"
                    style={{
                      marginLeft: 0,
                      marginRight: 0,
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: F_Fammily.Medium,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingBottom: "3%",
                        paddingTop: "3%",
                        paddingLeft: "18px",
                        paddingRight: "18px",
                        backgroundColor: "white",
                        borderRadius: "20px",
                        color: "black",
                        fontWeight: "bolder",
                        fontSize: "18px",
                      }}
                    >
                      <span>DINE-IN</span>
                      <span>{`Table ${qrTableNo}`}</span>
                    </div>
                  </div>
                ) : (
                  <div
                    className="DTSwitchBox"
                    style={{
                      marginLeft: CSP === "AV" ? "" : "4%",
                      width: CSP === "DT" ? "90%" : "96%",
                      display: "flex",
                    }}
                  >
                    {this.state.deliveryDisabled ? null : (
                      <div
                        style={{
                          fontFamily: F_Fammily.Medium,
                          width: this.state.takeawayDisabled ? "100%" : "50%",
                          textAlign: "center",
                          paddingBottom: "3%",
                          paddingTop: "3%",
                          cursor: this.state.deliveryDisabled
                            ? "default"
                            : "pointer",
                          backgroundColor:
                            this.state.ActiveIndex === 0
                              ? "white"
                              : "rgb(196, 192, 192)",
                          borderRadius: "20px",
                          color:
                            this.state.ActiveIndex === 0
                              ? "black"
                              : this.state.deliveryDisabled
                                ? "grey"
                                : "black",
                          opacity:
                            this.state.ActiveIndex === 0
                              ? 1
                              : this.state.deliveryDisabled
                                ? 0.5
                                : 1,
                          fontWeight:
                            this.state.ActiveIndex === 0 ? "bolder" : "normal",
                          fontSize:
                            this.state.ActiveIndex === 0 ? "18px" : "15px",
                        }}
                        onClick={() => {
                          if (!this.state.deliveryDisabled) {
                            this.setState({ ActiveIndex: 0 });
                            dto_common.DineType = 4;
                            SET_STORE_DINE_TYPE(4);
                          }
                        }}
                      >
                        {this.state.takeawayDisabled
                          ? "DELIVERY ONLY"
                          : "DELIVERY"}
                      </div>
                    )}
                    {this.state.takeawayDisabled ? null : (
                      <div
                        style={{
                          fontFamily: F_Fammily.Medium,
                          width: this.state.deliveryDisabled ? "100%" : "50%",
                          textAlign: "center",
                          cursor: this.state.takeawayDisabled
                            ? "default"
                            : "pointer",
                          paddingBottom: "3%",
                          paddingTop: "3%",
                          backgroundColor:
                            this.state.ActiveIndex === 1
                              ? "white"
                              : "rgb(196, 192, 192)",
                          borderRadius: "20px",
                          color:
                            this.state.ActiveIndex === 1
                              ? "black"
                              : this.state.takeawayDisabled
                                ? "grey"
                                : "black",
                          opacity:
                            this.state.ActiveIndex === 1
                              ? 1
                              : this.state.takeawayDisabled
                                ? 0.5
                                : 1,
                          fontWeight:
                            this.state.ActiveIndex === 1 ? "bolder" : "normal",
                          fontSize:
                            this.state.ActiveIndex === 1 ? "18px" : "15px",
                        }}
                        onClick={() => {
                          if (!this.state.takeawayDisabled) {
                            this.setState({ ActiveIndex: 1 });
                            dto_common.DineType = 3;
                            SET_STORE_DINE_TYPE(3);
                          }
                        }}
                      >
                        {this.state.deliveryDisabled
                          ? "PICK UP ONLY"
                          : "PICK UP"}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {this.state.CateList.length !== 0 ? (
              <div>
                <div
                  style={{
                    backgroundColor: "white",
                    position: "fixed",
                    left: isMobile ? 0 : WebLeft,
                    width: isMobile ? "100%" : WebWidth,
                    right: 0,
                    zIndex: 1500,
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    overflowY: "hidden",
                    padding: 5,
                    top: 48,
                    display: CSP === "MK" || CSP === "DT" ? "block" : "none",
                  }}
                  id={CSP === "MK" || CSP === "DT" ? "cateSection" : ""}
                >
                  {CSP !== "MK" && CSP !== "DT" ? (
                    categoryList.map((cate, i) => {
                      const PrdList = this.getCategoryProducts(cate);
                      const isActiveCategory =
                        String(this.state.activeCategoryId) ===
                        String(cate.CATID);

                      if (PrdList.length > 0) {
                        return (
                          <div
                            key={"verticalKEY" + i + cate.CATID}
                            className={cate.CATID + "SECTIONS  btnCategorys"}
                            id={"vertical" + cate.CATID}
                            data-catid={cate.CATID}
                            style={{
                              color: isActiveCategory ? "white" : "black",
                              border: "none",
                              backgroundColor: isActiveCategory
                                ? Colors.DarkGreyScale
                                : Colors.LightGreyScale,
                              float: "none",
                              display: "inline-block",
                              zoom: 1,
                              padding: 8,
                              paddingTop: 12,
                              paddingBottom: 12,
                              marginRight: 5,
                              height: "36px",
                              fontSize: "12px",
                              fontFamily: F_Fammily.Medium,
                              borderRadius: "5px",
                            }}
                            onClick={() => {
                              this.handleCategorySelect(cate);
                            }}
                          >
                            {/* {cate.Cat.toUpperCase()} */}
                            {cate.Category.toUpperCase()}
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })
                  ) : (
                    <div>
                      {/* HORIZONTAL CATEGORY */}
                      <div
                        id="horizontalCateSection"
                        style={{
                          padding: "10px",
                          display:
                            this.props.params.isSec === "true" ||
                            isInlinePromoMode
                              ? "none"
                              : "flex",
                          overflowX: "auto",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {selectableCategoryEntries.map((cate, i) => {
                          const isActiveCategory =
                            String(this.state.activeCategoryId) ===
                            String(cate.CATID);
                          return (
                            <div
                              data-catid={cate.CATID}
                              key={"dropdownKey" + i + cate.CATID}
                              style={{
                                backgroundColor: isActiveCategory
                                  ? Colors.DarkGreyScale
                                  : "white",
                                color: isActiveCategory
                                  ? "white"
                                  : Colors.DarkGreyScale,
                                border: "1px solid #474747",
                                fontWeight: "bold",
                                fontSize: "14px",
                                padding: "8px 12px",
                                whiteSpace: "normal",
                                flex: "0 0 auto",
                                marginRight: "10px",
                                borderRadius: "6px",
                                textAlign: "center",
                              }}
                              onClick={async () => {
                                await this.handleCategorySelect(cate, {
                                  offset: 110,
                                  shouldLoadProducts:
                                    this.shouldLoadProductsForCategorySelect(
                                      cate,
                                    ),
                                });
                              }}
                            >
                              {cate.Category.toUpperCase()}
                            </div>
                          );
                        })}
                      </div>

                      {/* CATEGORY HEADER */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "10% 75% 15%",
                          alignItems: "center",
                        }}
                      >
                        {/* Left - Menu Icon */}
                        <i
                          className="bi bi-list"
                          style={{
                            fontSize: 18,
                            borderRadius: "18px",
                            marginLeft: "6px",
                            marginRight: "6px",
                            color: "white",
                            padding: "3px 4px",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            justifySelf: "start",
                          }}
                          onClick={() =>
                            this.setState({
                              showDropdown: !this.state.showDropdown,
                            })
                          }
                        />

                        {/* Center - Header */}
                        <h1
                          id="SelectedCat"
                          style={{
                            fontSize: 21,
                            fontFamily: F_Fammily.Medium,
                            margin: 0,
                            fontWeight: "bold",
                            wordWrap: "break-word",
                            color: "black",
                            padding: "5px",
                            textAlign: "center",
                          }}
                        />

                        {CSP !== "AV" && (CSP !== "DT" || isInlinePromoMode) ? (
                          <i
                            className="bi bi-funnel"
                            style={{
                              fontSize: 18,
                              borderRadius: "18px",
                              marginLeft: "6px",
                              marginRight: "6px",
                              color: "white",
                              padding: "3px 4px",
                              backgroundColor: "rgba(0, 0, 0, 0.8)",
                              justifySelf: "end",
                            }}
                            onClick={() =>
                              this.setState({
                                showSortDropDown: true,
                              })
                            }
                          />
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>

                <div
                  className="container"
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: isInlinePromoMode ? 60 : CSP === "MK" ? 90 : 0,
                  }}
                >
                  <div>
                    {productCategoryList.map((cate, i) => {
                      const PrdList = this.getCategoryProducts(cate);
                      if (PrdList.length > 0) {
                        return (
                          <div
                            className="ItemList"
                            id={cate.CATID + "SECTIONS"}
                            key={cate.CATID + "ProductList" + i + "Key"}
                          >
                            <div
                              className="row"
                              key={cate.CATID + i + "Key"}
                              style={{ display: "block" }}
                            >
                              <Category
                                // Category={cate.Cat.toUpperCase()}
                                Category={cate.Category.toUpperCase()}
                                ID={cate.CATID}
                                key={cate.CATID + "CategoryHeading" + i + "Key"}
                              />
                            </div>
                            <div className="" key={i + cate.CATID + "PRD"}>
                              {PrdList.map((item, i) => {
                                return (
                                  <React.Fragment
                                    key={item.PI + "ProductListFragment" + i}
                                  >
                                    <ItemView
                                      onCartUpdated={(updatedCart) => {
                                        this.setState({
                                          LocalCart: updatedCart || [],
                                        });
                                      }}
                                      onClick={async (rs, index) => {
                                        await Api_DrawAnalyticalPath(1, rs);
                                        ENCRYPT_STORAGE_SESSION.setItem(
                                          "PrdIdScroll",
                                          rs + "PRD" + index,
                                        );

                                        // Always allow navigation to product detail when clicking the item (including when W is true)
                                        this.props.navigate(
                                          PT_PRODUCT.replace(
                                            ":frompage",
                                            "product-list",
                                          )
                                            .replace(
                                              ":navigatepage",
                                              this.getProductDetailNavigatePage(),
                                            )
                                            .replace(
                                              ":category",
                                              // cate.Cat.replace(
                                              cate.Category.replace(
                                                "/",
                                                "-",
                                              ).toLowerCase(),
                                            )
                                            .replace(":pid", rs)
                                            .replace(":lineid", 1)
                                            .replace(":adonlineid", 1)
                                            .replace(":isrecommended", 0),
                                        );
                                        this.safariTouchFix();
                                      }}
                                      key={item.PI + "ProductList" + i}
                                      pid={item.PI}
                                      data={item}
                                      index={i}
                                      Description={item.D}
                                      GenDesc={item.G}
                                      SP={item.P}
                                      UD={item.UD}
                                      IsAvailable={item.A}
                                      ProductImage={
                                        <div className="">
                                          {item.IU !== "" &&
                                          item.IU !== "N/A" ? (
                                            <img
                                              style={{
                                                height: 70,
                                                width: 70,
                                                padding: 0,
                                                borderRadius: 10,
                                              }}
                                              loading="lazy"
                                              id={"prdImageLise" + item.PI}
                                              // src={
                                              //   "https://www.daitonnmail.com/" +
                                              //   item.IU.split("λ")[0]
                                              // }
                                              src={item.IU.split("λ")[0]}
                                              alt=""
                                              onError={(e) => {
                                                e.currentTarget.src =
                                                  dto_common.DefaultImageUrl;
                                              }}
                                            />
                                          ) : (
                                            <img
                                              style={{
                                                height: 30,
                                                width: 30,
                                                padding: 0,
                                                borderRadius: 10,
                                                filter: "grayscale(100%)",
                                                WebkitFilter: "grayscale(100%)",
                                              }}
                                              src={dto_common.DefaultImageUrl}
                                              onError={(e) => {
                                                e.currentTarget.src =
                                                  dto_common.DefaultImageUrl;
                                              }}
                                              alt=""
                                            />
                                          )}
                                        </div>
                                      }
                                    />
                                    <div
                                      style={{
                                        borderTop: "1px solid black",
                                        transform: "scaleY(0.1)",
                                        display: "block",
                                      }}
                                    />
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </div>

                  {this.state.displayMessage
                    ? this.renderNoMatchState("70px")
                    : null}
                  {!this.state.displayMessage && CSP === "MK" ? (
                    <div
                      style={{
                        backgroundColor: Colors.DarkGreyScale,
                        borderRadius: "4px",
                        color: "white",
                        display: CSP === "MK" ? "block" : "none",
                        margin: "24px auto 0",
                        padding: "4px 8px",
                        textAlign: "center",
                        width: "fit-content",
                      }}
                      onClick={() => {
                        this.props.navigate(
                          PT_FILTER_OUTLETS_PRODUCTS.replace(
                            ":frmpath",
                            "category",
                          ),
                        );
                        ENCRYPT_STORAGE.setItem(
                          "SearchStringFilter",
                          this.state.filterText,
                        );
                      }}
                    >
                      Find More
                    </div>
                  ) : null}
                </div>

                {!this.state.displayMessage ? (
                  <button
                    id="ScrollToTopBTN"
                    title="Go to top"
                    style={{ left: isMobile ? "80%" : "63%" }}
                    onClick={() => {
                      if (isMobile) {
                        window.scrollTo({ top: 10, behavior: "smooth" });
                      } else {
                        const el = document.querySelector(".WindowDevice");
                        el && el.scrollTo({ top: 10, behavior: "smooth" });
                      }
                    }}
                  >
                    <i
                      className="bi bi-arrow-up-square"
                      style={{ fontSize: 28 }}
                    />
                  </button>
                ) : null}

                {/* View Basket For View Cart */}
                {this.state.LocalCart.length > 0 &&
                ((this.state.LocalCart[0].MID === dto_Merchant.MID &&
                  CSP !== "DT" &&
                  CSP !== "MK") ||
                  CSP === "MK" ||
                  CSP === "DT") ? (
                  <button
                    id="QuickCartBTN"
                    style={{
                      position: "fixed",
                      background:
                        "linear-gradient(135deg, rgb(46, 41, 41) 0%, rgb(83, 78, 78) 100%)",
                      bottom:
                        entryMode === "QR" &&
                        (dto_Customer.CSID === 0 ||
                          dto_Customer.CSID === undefined)
                          ? "10px"
                          : "52px",
                      zIndex: 99,
                      padding: "5px 6px 5px 16px",
                      outline: "none",
                      borderRadius: "100px",
                      fontSize: 16,
                      color: "white",
                      left: "50%",
                      transform: "translateX(-50%)",
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "12px",
                      minWidth: isMobile ? "calc(100% - 28px)" : "330px",
                      maxWidth: isMobile ? "calc(100% - 28px)" : "360px",
                      boxShadow: "0 12px 28px rgba(0, 0, 0, 0.22)",
                      border: "1px solid rgba(255, 255, 255, 0.08)",
                    }}
                    onClick={async () => {
                      let Localcart = await GET_CART();
                      if (Localcart === undefined) {
                        Localcart = [];
                      }
                      this.setState(
                        { IsSummaryCart: true, LocalCart: Localcart },
                        async () => {
                          await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(
                            async () => {
                              let Localcart = await GET_CART();
                              if (Localcart === undefined) {
                                Localcart = [];
                              }
                              this.setState({
                                IsSummaryCart: false,
                                LocalCart: Localcart,
                              });
                            },
                          );
                        },
                      );
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        lineHeight: 1.1,
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "700",
                          fontSize: "17px",
                        }}
                      >
                        {this.state.LocalCart.length}{" "}
                        {this.state.LocalCart.length === 1 ? "Item" : "Items"}
                      </span>
                    </span>
                    <span
                      style={{
                        fontWeight: "700",
                        padding: "6px 10px",
                        borderRadius: "999px",
                        backgroundColor: "rgba(255, 255, 255, 0.14)",
                        border: "1px solid rgba(255,255,255,0.12)",
                        fontSize: "15px",
                        flexShrink: 0,
                      }}
                    >
                      {this.getTotalPrice()}
                    </span>
                  </button>
                ) : null}
              </div>
            ) : (
              this.renderNoMatchState("70px")
            )}
          </>
        )}

        {/* {CSP === "AV" ? (
          <DrawerSheet
            open={this.state.showDropdown}
            closeFunction={() => this.setState({ showDropdown: false })}
            element={
              <div style={{ position: "relative", height: "100%" }}>
                <div
                  style={{
                    maxHeight: "calc(100% - 70px)",
                    overflowY: "auto",
                  }}
                >
                  {this.state.CategoryList.map((cate, i) => {
                    return (
                      <div
                        data-catid={cate.CATID}
                        key={"dropdownKey" + i + cate.CATID}
                        style={{
                          padding: "12px 12px",
                          cursor: "pointer",
                          fontSize: "16px",
                          borderBottom: "1px solid #eee",
                        }}
                      onClick={async () => {
                        await this.handleCategorySelect(cate, {
                          closeDropdown: true,
                        });
                      }}
                      >
                        {cate.Category.toUpperCase()}
                      </div>
                    );
                  })}
                </div>

                <button
                  style={{
                    position: "absolute",
                    bottom: 10,
                    cursor: "pointer",
                    width: "100%",
                    height: "48px",
                    background: Colors.DarkGreyScale,
                    fontFamily: F_Fammily.Medium,
                    color: Colors.FontColor,
                    borderRadius: "8px",
                    marginTop: 6,
                    border: "none",
                    fontSize: "20px",
                  }}
                  onClick={() => this.setState({ showDropdown: false })}
                >
                  {" "}
                  DISMISS{" "}
                </button>
              </div>
            }
            size={isMobile ? "85%" : 280}
            Heading="Categories"
          />
        ) : ( */}
        <DrawerSheetBottom
          open={this.state.showDropdown}
          closeFunction={() => this.setState({ showDropdown: false })}
          displayCloseIcon="block"
          element={
            <div style={{ position: "relative", height: "100%" }}>
              <div
                style={{
                  //                   maxHeight: "calc(100% - 60px)",
                  maxHeight: "calc(100% - 70px)",
                  overflowY: "auto",
                }}
              >
                {selectableCategoryEntries.map((cate, i) => {
                  return (
                    <div
                      data-catid={cate.CATID}
                      key={"dropdownKey" + i + cate.CATID}
                      style={{
                        padding: "12px 12px",
                        cursor: "pointer",
                        fontSize: "16px",
                        borderBottom: "1px solid #eee",
                      }}
                      onClick={async () => {
                        await this.handleCategorySelect(cate, {
                          closeDropdown: true,
                          shouldLoadProducts:
                            this.shouldLoadProductsForCategorySelect(cate),
                        });
                      }}
                    >
                      {cate.Category.toUpperCase()}
                    </div>
                  );
                })}
              </div>

              <button
                style={{
                  position: "absolute",
                  bottom: 10,
                  cursor: "pointer",
                  width: "100%",
                  height: "48px",
                  background: Colors.DarkGreyScale,
                  fontFamily: F_Fammily.Medium,
                  color: Colors.FontColor,
                  borderRadius: "8px",
                  marginTop: 6,
                  border: "none",
                  fontSize: "20px",
                }}
                onClick={() => this.setState({ showDropdown: false })}
              >
                {" "}
                DISMISS{" "}
              </button>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Categories"
        />
        {/* )} */}

        {/* {CSP === "AV" ? (
          <DrawerSheet
            open={this.state.IsSummaryCart}
            element={
              <SummaryCart
                CartData={this.state.LocalCart}
                navigate={this.props.navigate}
                ItemClick={async (item) => {
                  this.setState({ IsSummaryCart: false }, () => {
                    this.props.navigate(
                      PT_PRODUCT.replace(":frompage", "cart")
                        .replace(":navigatepage", "product-list")
                        .replace(":category", "category")
                        .replace(":pid", item.PID)
                        .replace(":lineid", item.LineID)
                        .replace(":adonlineid", item.ADDONLINEID)
                        .replace(":isrecommended", 0),
                    );
                  });
                }}
                closeFunction={() =>
                  this.setState({ IsSummaryCart: false }, () => {
                    this.safariTouchFix();
                  })
                }
              />
            }
            size={isMobile ? "85%" : 280}
            Heading="Shopping List"
          />
        ) : ( */}
        <DrawerSheetBottom
          open={this.state.IsSummaryCart}
          closeFunction={() =>
            this.setState({ IsSummaryCart: false }, () => {
              this.safariTouchFix();
            })
          }
          element={
            <SummaryCart
              CartData={this.state.LocalCart}
              navigate={this.props.navigate}
              ItemClick={async (item) => {
                this.setState({ IsSummaryCart: false }, () => {
                  this.props.navigate(
                    PT_PRODUCT.replace(":frompage", "cart")
                      .replace(":navigatepage", "product-list")
                      .replace(":category", "category")
                      .replace(":pid", item.PID)
                      .replace(":lineid", item.LineID)
                      .replace(":adonlineid", item.ADDONLINEID)
                      .replace(":isrecommended", 0),
                  );
                });
              }}
              onCartUpdated={(updatedCart) => {
                this.setState({
                  LocalCart: updatedCart || [],
                });
              }}
              closeFunction={() =>
                this.setState({ IsSummaryCart: false }, () => {
                  this.safariTouchFix();
                })
              }
            />
          }
          size={isMobile ? "85%" : 280}
          Heading="Shopping List"
        />
        {/* )} */}

        <DrawerSheetBottom
          open={this.state.showSortDropDown}
          closeFunction={() => this.setState({ showSortDropDown: false })}
          element={
            <div>
              {/* A-Z */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("A_TO_Z")}
              >
                <i
                  className="bi bi-sort-alpha-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Sort A - Z
                </span>
              </div>
              <br />

              {/* Z-A */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("Z_TO_A")}
              >
                <i
                  className="bi bi-sort-alpha-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Sort Z - A
                </span>
              </div>
              <br />

              {/* Price Low to High */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("PRICE_LOW_TO_HIGH")}
              >
                <i
                  className="bi bi-sort-numeric-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Price low to high
                </span>
              </div>
              <br />

              {/* Price High to Low */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("PRICE_HIGH_TO_LOW")}
              >
                <i
                  className="bi bi-sort-numeric-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Price high to low
                </span>
              </div>
              <br />

              {/* Discount Low to High */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("DISCOUNT_LOW_TO_HIGH")}
              >
                <i
                  className="bi bi-sort-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Discounts % low to high
                </span>
              </div>
              <br />

              {/* Discount High to Low */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("DISCOUNT_HIGH_TO_LOW")}
              >
                <i
                  className="bi bi-sort-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Discounts % high to low
                </span>
              </div>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Sort Products"
        />
      </div>
    );
  }

  async Setdinetype() {
    const storedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
    let dataStorage = ENCRYPT_STORAGE.getItem(STORE_PRODUCT_LIST);
    const MerchantDetails =
      dataStorage?.MerchantData ||
      this.state.MerchantData ||
      dto_selected_final_merchant_or_product ||
      dto_selected_merchant_or_product;

    if (
      MerchantDetails === undefined ||
      MerchantDetails === null ||
      Number.isNaN(Number(MerchantDetails?.MID))
    ) {
      return;
    }

    const resolvedSelection = resolveDineTypeSelection({
      availableDineType: MerchantDetails.DineType,
      storedDineType,
    });

    dto_common.DineType = resolvedSelection.selectedDineType;
    SET_STORE_DINE_TYPE(resolvedSelection.selectedDineType);
    this.setState({
      ActiveIndex: resolvedSelection.activeIndex,
      deliveryDisabled: resolvedSelection.deliveryDisabled,
      takeawayDisabled: resolvedSelection.takeawayDisabled,
    });
  }

  sortProducts = (sortType) => {
    const ProductListt = [...this.state.PrdList];
    const selectedCATID = dto_selected_merchant_or_product.CATID;
    let targetIndex = ProductListt.findIndex(
      (item) => item.CATID === selectedCATID,
    );

    if (targetIndex === -1) {
      targetIndex = 0;
    }

    if (!ProductListt[targetIndex]) {
      this.setState({ showSortDropDown: false });
      return;
    }

    const PromoProductList = { ...ProductListt[targetIndex] };
    let PrdList = JSON.parse(PromoProductList.dtoProductSessionList || "[]");

    switch (sortType) {
      case "A_TO_Z":
        PrdList.sort((a, b) => {
          const nameA = a.D?.toLowerCase() || "";
          const nameB = b.D?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });
        break;

      case "Z_TO_A":
        PrdList.sort((a, b) => {
          const nameA = a.D?.toLowerCase() || "";
          const nameB = b.D?.toLowerCase() || "";
          return nameB.localeCompare(nameA);
        });
        break;

      case "PRICE_LOW_TO_HIGH":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const priceB = parseFloat(b.P) || 0;
          return priceA - priceB;
        });
        break;

      case "PRICE_HIGH_TO_LOW":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const priceB = parseFloat(b.P) || 0;
          return priceB - priceA;
        });
        break;

      case "DISCOUNT_LOW_TO_HIGH":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const discountPriceA = parseFloat(a.UD) || 0;
          const priceB = parseFloat(b.P) || 0;
          const discountPriceB = parseFloat(b.UD) || 0;

          // Calculate discount percentage
          const discountPercentA =
            priceA > 0 ? ((priceA - discountPriceA) / priceA) * 100 : 0;
          const discountPercentB =
            priceB > 0 ? ((priceB - discountPriceB) / priceB) * 100 : 0;

          return discountPercentA - discountPercentB;
        });
        break;

      case "DISCOUNT_HIGH_TO_LOW":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const discountPriceA = parseFloat(a.UD) || 0;
          const priceB = parseFloat(b.P) || 0;
          const discountPriceB = parseFloat(b.UD) || 0;

          // Calculate discount percentage
          const discountPercentA =
            priceA > 0 ? ((priceA - discountPriceA) / priceA) * 100 : 0;
          const discountPercentB =
            priceB > 0 ? ((priceB - discountPriceB) / priceB) * 100 : 0;

          return discountPercentB - discountPercentA;
        });
        break;

      default:
        break;
    }

    PromoProductList.dtoProductSessionList = JSON.stringify(PrdList);
    ProductListt[targetIndex] = PromoProductList;
    this.setState({
      PrdList: ProductListt,
      CateList: ProductListt,
      showSortDropDown: false,
    });

    if (isMobile) {
      $("html,body").animate({ scrollTop: 10 }, 700);
    } else {
      $(".WindowDevice").animate({ scrollTop: 10 }, 700);
    }
  };

  async TransformationFillterTextBox() {
    this.openFilterBox();
  }

  async LoadMasterCategory() {
    if (!this.shouldLoadGroceryCategories()) {
      await this.setStateAsync({ CategoryList: [] });
      return;
    }

    const data = await api_CategoryPageLoadGroceryCategory();
    const objData = JSON.parse(data);
    await this.setStateAsync({ CategoryList: objData });
  }

  async LoadApiProduct() {
    const data = await api_LoadProductListToMobileAppForAnMID();
    const ObjData = JSON.parse(data);
    const ProductList = ObjData[0];
    let ProductListt;
    if (
      (CSP === "MK" &&
        dto_selected_merchant_or_product.CATID !== 1 &&
        ProductList.length !== 1) ||
      (CSP === "DT" &&
        dto_selected_merchant_or_product.Merchant === "MKB Supermarket" &&
        dto_selected_merchant_or_product.CATID !== 1)
    ) {
      let withoutOffer = ProductList.filter(
        (item) => item.Category !== "OFFER",
      );
      ProductListt = withoutOffer;
    } else {
      ProductListt = ProductList;
    }
    let MerchantDataa = this.resolveMerchantData(ObjData[1]);
    if (!this.hasValidMerchantData(MerchantDataa)) {
      const merchantLoadError = new Error("Merchant data missing");
      merchantLoadError.isMerchantDataLoadFailed = true;
      throw merchantLoadError;
    }
    this.latestMerchantData = MerchantDataa;
    this.setState({ MerchantData: MerchantDataa });
    ENCRYPT_STORAGE.removeItem(STORE_PRODUCT_LIST);
    ENCRYPT_STORAGE.setItem(STORE_PRODUCT_LIST, {
      ProductList: ProductListt,
      MID: MerchantDataa.MID,
      MerchantData: MerchantDataa,
      date: new Date(),
      CATID: dto_selected_merchant_or_product.CATID,
    });
    this.setCachedQrProductList({
      ProductList: ProductListt,
      MID: MerchantDataa.MID,
      MerchantData: MerchantDataa,
      CATID: dto_selected_merchant_or_product.CATID,
    });
    return ProductListt;
  }

  async LoadProduct() {
    try {
      this.setState({ isLoading: true, desc: "" });
      let dataStorage = this.getCachedQrProductList();
      if (!dataStorage) {
        dataStorage = ENCRYPT_STORAGE.getItem(STORE_PRODUCT_LIST);
      }
      let data = "";
      let merchantData = null;
      if (dataStorage !== undefined && dataStorage !== "") {
        if (dataStorage.MID === dto_selected_merchant_or_product.MID) {
          const cachedQrData = this.getCachedQrProductList();
          if (cachedQrData) {
            data = cachedQrData.ProductList;
            merchantData = this.resolveMerchantData(cachedQrData.MerchantData);
            this.latestMerchantData = merchantData;
            this.setState({ MerchantData: merchantData });
          } else {
            let StorageDateTime = new Date(dataStorage.date);
            let currentDateTime = new Date();
            let DifferenceMinute = DIFERENCE_MINUTES(
              currentDateTime,
              StorageDateTime,
            );
            if (DifferenceMinute > 1) {
              ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
              data = await this.LoadApiProduct();
            } else {
              if (
                dto_selected_merchant_or_product.MT === "GR" ||
                dto_selected_merchant_or_product.MT === "AF" ||
                CSP === "MK" ||
                CSP === "DT"
              ) {
                if (
                  dataStorage.CATID === dto_selected_merchant_or_product.CATID
                ) {
                  data = dataStorage.ProductList;
                  merchantData = this.resolveMerchantData(
                    dataStorage.MerchantData,
                  );
                  this.latestMerchantData = merchantData;
                  this.setState({ MerchantData: merchantData });
                } else {
                  ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                  data = await this.LoadApiProduct();
                  merchantData = this.latestMerchantData;
                }
              } else {
                data = dataStorage.ProductList;
                merchantData = this.resolveMerchantData(
                  dataStorage.MerchantData,
                );
                this.latestMerchantData = merchantData;
                this.setState({ MerchantData: merchantData });
              }
            }
          }
        } else {
          ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
          data = await this.LoadApiProduct();
          merchantData = this.latestMerchantData;
        }
      } else {
        ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
        data = await this.LoadApiProduct();
        merchantData = this.latestMerchantData;
      }

      merchantData = this.resolveMerchantData(merchantData);
      if (!this.hasValidMerchantData(merchantData)) {
        const merchantLoadError = new Error("Merchant data missing");
        merchantLoadError.isMerchantDataLoadFailed = true;
        throw merchantLoadError;
      }

      let Localcart = await GET_CART();
      if (Localcart === undefined) {
        Localcart = [];
      }

      const fallbackCategoryList =
        this.state.CategoryList.length > 0
          ? this.state.CategoryList
          : this.buildCategoryListFromProducts(data);

      this.setState(
        {
          CateList: data,
          PrdList: data,
          inMemoryProducts: data,
          isLoading: false,
          LocalCart: Localcart,
          CategoryList: fallbackCategoryList,
        },
        () => {
          if (this.state.filterText.trim() !== "") {
            this.applyFilter(this.state.filterText, data);
          }
        },
      );

      setTimeout(async () => {
        if (!this.state.isLoading) {
          await this.ScrollIndicaterMenu();
        }
      }, 500);

      setTimeout(() => {
        let PID = ENCRYPT_STORAGE_SESSION.getItem("PrdIdScroll");
        if (PID !== undefined) {
          this.scrollToTarget(PID, 110);
        } else {
          const container = isMobile
            ? document.querySelector(".body-container")
            : document.querySelector(".WindowDevice");
          if (container && container.scrollTo) {
            container.scrollTo({ top: 10, behavior: "auto" });
          } else {
            window.scrollTo({ top: 10, behavior: "auto" });
          }
        }
      }, 500);
      setTimeout(() => {
        let cateSection = document.getElementById("cateSection");
        if (cateSection) {
          cateSection.style.display = CSP === "MK" ? "block" : "none";
        }
      }, 50);
    } catch (error) {
      console.error("LoadProductList : " + error);
      if (error?.isInvalidQrMerchant) {
        ENCRYPT_STORAGE.setItem(STORE_INVALID_QR, true);
        this.setState({
          invalidQr: true,
          displayMessage: true,
          isLoading: false,
          CateList: [],
          PrdList: [],
          inMemoryProducts: [],
        });
        return;
      }
      if (error?.isApiRecoveryRedirect) {
        this.setState({
          isLoading: false,
        });
        return;
      }
      if (error?.isMerchantDataLoadFailed) {
        this.setState({
          isLoading: false,
          displayMessage: true,
          CateList: [],
          PrdList: [],
          inMemoryProducts: [],
          desc: "Merchant information could not be loaded. Please try again.",
        });
        return;
      }
      ToastMessage(1, "Unable to load products. Please try again.");
      this.setState({
        isLoading: false,
      });
    }
  }

  async loadSubProduct() {
    try {
      await this.setStateAsync({ isLoading: true });
      const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
      const isPosQr = CSP === "DT" && entryMode === "QR";
      let SelectedCATID = dto_selected_merchant_or_product.CATID;
      let prdlist = this.state.PrdList;
      let isAllCat = localStorage.getItem("isAllCat");

      const categoryList =
        this.state.CategoryList.length > 0
          ? this.state.CategoryList
          : this.buildCategoryListFromProducts(prdlist);
      const firstCategory = categoryList.find(
        (item) => Number(item?.CATID) !== 0,
      );
      let firstCATID = firstCategory?.CATID ?? SelectedCATID ?? 0;
      localStorage.setItem("firstCATID", firstCATID);

      if (isPosQr) {
        const fullList = await this.LoadApiProduct();
        await this.setStateAsync({
          PrdList: fullList,
          CateList: fullList,
          inMemoryProducts: fullList,
          isLoading: false,
        });
        requestAnimationFrame(() => {
          const targetCATID = SelectedCATID === 0 ? firstCATID : SelectedCATID;
          const selectedCategory =
            categoryList.find(
              (item) => String(item.CATID) === String(targetCATID),
            )?.Category || "";
          this.scrollToCategorySection(targetCATID, selectedCategory);
          this.safariTouchFix();
        });
        return;
      }

      const isMatch = prdlist.some((item) => item.CATID === SelectedCATID);
      if (!isMatch || firstCATID === SelectedCATID) {
        if (isAllCat === "true") {
          let data = await this.LoadApiProduct();
          await this.setStateAsync((prevState) => ({
            PrdList: [...prevState.PrdList, ...data],
          }));
        } else {
          let data = await this.LoadApiProduct();
          await this.setStateAsync({ PrdList: data });
        }
      } else if (isMatch && SelectedCATID === prdlist[0].CATID) {
        let data = await this.LoadApiProduct();
        await this.setStateAsync({ PrdList: data });
      } else {
        let data = await this.LoadApiProduct();
        await this.setStateAsync({ PrdList: data });
      }

      await this.setStateAsync({ isLoading: false });
    } catch (error) {
      console.error("Error loading sub-products:", error);
    }
  }

  async ScrollIndicaterMenu() {
    let ItemSection = document.getElementsByClassName("ItemList");
    // let CateSection = document.getElementsByClassName("btnCategorys");

    let element;
    if (isMobile) {
      element = document.querySelector(".body-container");
    } else {
      element = document.querySelector(".WindowDevice");
    }

    // Reset scroll event listener on manual category change
    if (element && this.handleScroll) {
      element.removeEventListener("scroll", this.handleScroll);
    }

    // Define the scroll logic as a separate function for reuse
    this.handleScroll = async () => {
      const top = element ? element.scrollTop : 0;
      for (let i = 0; i < ItemSection.length; i++) {
        let offset = ItemSection[i].offsetTop - 120;
        let Height = ItemSection[i].offsetHeight;
        let ID = ItemSection[i].id;
        let ScrollToTopBTN = document.getElementById("ScrollToTopBTN");

        if (top > 252) {
          const cateSection = document.getElementById("cateSection");
          if (cateSection) {
            cateSection.style.display = "block";
          }
          if (CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF") {
            $("#DivHeaderHome").show(500);
          }
        } else {
          const cateSection = document.getElementById("cateSection");
          if (cateSection) {
            cateSection.style.display = CSP === "MK" ? "block" : "none";
          }
          if (CSP !== "MK" && dto_selected_merchant_or_product.MT !== "AF") {
            $("#DivHeaderHome").hide(500);
            this.setState({
              MainTopMargin: "0px",
              iconDisplay: "block",
            });
          }
        }

        if (ScrollToTopBTN) {
          if (top > 1630) {
            ScrollToTopBTN.style.display = "none";
          } else {
            ScrollToTopBTN.style.display = "none";
          }
        }

        if (top >= offset && top < offset + Height) {
          if (CSP === "MK" || CSP === "DT") {
            let x = document.getElementById(ID);
            let CategoryName = x.querySelector("h1").innerText;
            const currentCATID = ID.replace("SECTIONS", "");
            const resolvedCategoryId = this.resolveCategoryId(
              currentCATID,
              CategoryName,
            );
            dto_selected_merchant_or_product.CATID = Number(resolvedCategoryId);
            this.syncActiveCategory(resolvedCategoryId, CategoryName);
            setTimeout(() => {
              this.safariTouchFix();
            }, 0);

            // 🔥 HORIZONTAL CATEGORY AUTO-SCROLL (MK / DT)

            if (
              CSP === "MK" ||
              (CSP === "DT" &&
                dto_selected_merchant_or_product.Merchant === "MKB Supermarket")
            ) {
              let SelectedCATID = dto_selected_merchant_or_product.CATID;
              const isScrolledToBottom =
                element.scrollTop + element.clientHeight >=
                element.scrollHeight;
              let CategoryList =
                this.state.CategoryList.length > 0
                  ? this.state.CategoryList
                  : this.buildCategoryListFromProducts(this.state.PrdList);
              let isAllCat = localStorage.getItem("isAllCat");

              if (isScrolledToBottom && isAllCat === "true") {
                if (CategoryList && CategoryList.length > 0) {
                  const index = CategoryList.findIndex(
                    (item) => item.CATID === SelectedCATID,
                  );

                  if (index !== -1 && index < CategoryList.length - 1) {
                    const nextCATID = CategoryList[index + 1].CATID;
                    SelectedCATID = dto_selected_merchant_or_product.CATID =
                      nextCATID;

                    await this.loadSubProduct();
                    this.safariTouchFix();
                  }
                }
              }
            }
          } else {
            const currentCATID = ID.replace("SECTIONS", "");
            let x = document.getElementById(ID);
            let CategoryName = x.querySelector("h1").innerText;
            dto_selected_merchant_or_product.CATID = Number(currentCATID);
            this.syncActiveCategory(currentCATID, CategoryName);

            const cateSection = document.getElementById("cateSection");
            const activeBtn = document.getElementById(
              "vertical" + currentCATID,
            );
            if (cateSection && activeBtn) {
              const left =
                activeBtn.offsetLeft -
                cateSection.clientWidth / 2 +
                activeBtn.clientWidth / 2;

              cateSection.scrollTo({
                left: Math.max(0, left),
                behavior: "smooth",
              });
            }
          }
        }
      }
    };

    // Reattach the scroll event listener
    if (element) {
      element.addEventListener("scroll", this.handleScroll);
    }

    // Ensure the initial scroll logic runs
    this.handleScroll();
  }

  handleFilterChange = (e) => {
    const filterText = e.target.value;
    this.setState({ filterText });
    this.applyFilter(filterText);
  };

  handleFindMoreAtOtherCategories = () => {
    const searchText = String(this.state.filterText || "").trim();
    if (searchText === "") {
      return;
    }

    ENCRYPT_STORAGE.setItem("SearchStringFilter", searchText);
    this.props.navigate(
      PT_FILTER_OUTLETS_PRODUCTS.replace(":frmpath", "category"),
    );
  };

  renderFindMoreAtOtherCategoriesButton = () => {
    if (CSP !== "MK" || String(this.state.filterText || "").trim() === "") {
      return null;
    }

    return (
      <button
        style={{
          backgroundColor: Colors.DarkGreyScale,
          borderRadius: "8px",
          color: "white",
          marginTop: "24px",
          padding: "12px 18px",
          textAlign: "center",
          border: "none",
          fontSize: "15px",
          fontFamily: F_Fammily.Medium,
          cursor: "pointer",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.14)",
        }}
        onClick={this.handleFindMoreAtOtherCategories}
      >
        Find More
      </button>
    );
  };

  renderNoMatchState = (marginTop = "70px") => {
    const isInvalidQr = this.state.invalidQr === true;
    const hasMerchantLoadError = String(this.state.desc || "").trim() !== "";

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: isInvalidQr ? "center" : "flex-start",
          marginTop: isInvalidQr ? 0 : marginTop,
          height: "100vh",
          width: "100%",
          backgroundColor: isInvalidQr ? "white" : undefined,
          position: isInvalidQr ? "fixed" : "relative",
          top: isInvalidQr ? 0 : undefined,
          left: isInvalidQr ? (isMobile ? 0 : WebLeft) : undefined,
          zIndex: isInvalidQr ? 4000 : undefined,
          maxWidth: isInvalidQr && !isMobile ? WebWidth : undefined,
        }}
      >
        <img
          src={
            isInvalidQr
              ? require("./images/FailQR.jpeg")
              : require("./images/NoDataFound.jpg")
          }
          width={"60%"}
          alt=""
        />

        <label
          style={{
            fontWeight: "bold",
            marginBottom: "8px",
            textAlign: "center",
          }}
        >
          {isInvalidQr
            ? "Invalid QR"
            : hasMerchantLoadError
              ? "Unable to load merchant details"
              : "We did not find a match"}
        </label>
        <label style={{ textAlign: "center" }}>
          {isInvalidQr
            ? "Please scan a valid QR code and try again"
            : hasMerchantLoadError
              ? this.state.desc
              : "Try searching for something instead"}
        </label>

        {!isInvalidQr && !hasMerchantLoadError
          ? this.renderFindMoreAtOtherCategoriesButton()
          : null}
      </div>
    );
  };

  renderFloatingQuickCartButton = (bottom = "52px") => {
    if (this.state.LocalCart.length === 0) {
      return null;
    }

    return createPortal(
      <button
        id="QuickCartBTN"
        style={{
          position: "fixed",
          background:
            "linear-gradient(135deg, rgb(46, 41, 41) 0%, rgb(83, 78, 78) 100%)",
          bottom,
          zIndex: 5000,
          padding: "5px 6px 5px 16px",
          outline: "none",
          borderRadius: "100px",
          fontSize: 16,
          color: "white",
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "left",
          whiteSpace: "nowrap",
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          gap: "12px",
          minWidth: isMobile ? "calc(100% - 28px)" : "330px",
          maxWidth: isMobile ? "calc(100% - 28px)" : "360px",
          boxShadow: "0 12px 28px rgba(0, 0, 0, 0.22)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
        }}
        onClick={async () => {
          this.setState({ IsSummaryCart: true }, async () => {
            await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(async () => {
              this.setState({
                IsSummaryCart: false,
              });
            });
          });
        }}
      >
        <span
          style={{
            display: "flex",
            flexDirection: "column",
            lineHeight: 1.1,
          }}
        >
          <span
            style={{
              fontWeight: "700",
              fontSize: "17px",
            }}
          >
            {this.state.LocalCart.length}{" "}
            {this.state.LocalCart.length === 1 ? "Item" : "Items"}
          </span>
        </span>
        <span
          style={{
            fontWeight: "700",
            padding: "6px 10px",
            borderRadius: "999px",
            backgroundColor: "rgba(255, 255, 255, 0.14)",
            border: "1px solid rgba(255,255,255,0.12)",
            fontSize: "15px",
            flexShrink: 0,
          }}
        >
          {this.getTotalPrice()}
        </span>
      </button>,
      document.body,
    );
  };

  checkIsFavourite() {
    let fav = ENCRYPT_STORAGE.getItem(STORE_FAVOURITE_MERCHANT_LIST);
    if (fav !== undefined) {
      for (let i = 0; i < fav.length; i++) {
        if (fav[i].MID === dto_Merchant.MID) {
          this.setState({ IsFavourite: true });
          return;
        }
      }
    }
  }

  applyFilter = (
    filterText = "",
    sourceProducts = this.state.inMemoryProducts,
  ) => {
    const normalizedFilterText = String(filterText || "")
      .toLowerCase()
      .trim();

    if (normalizedFilterText === "") {
      this.setState({
        CateList: sourceProducts,
        PrdList: sourceProducts,
        displayMessage: false,
      });
      return;
    }

    const filteredCateList = sourceProducts
      .map((category) => {
        const filteredProducts = this.getCategoryProducts(category).filter(
          (product) =>
            String(product?.D || "")
              .toLowerCase()
              .includes(normalizedFilterText),
        );
        return {
          ...category,
          dtoProductSessionList: JSON.stringify(filteredProducts),
        };
      })
      .filter((category) => this.getCategoryProducts(category).length > 0);

    this.setState({
      CateList: filteredCateList,
      PrdList: filteredCateList,
      displayMessage: filteredCateList.length === 0,
    });
  };

  resetFilter = () => {
    this.setState({ filterText: "" }, () => {
      this.applyFilter("", this.state.inMemoryProducts);
      this.focusSearchInput();
    });
  };

  handleCancelClick = () => {
    this.closeFilterBox({ reset: true });
  };

  handleHeartClick = async (event) => {
    // Toggle IsFavourite state
    this.setState(
      (prevState) => ({ IsFavourite: !prevState.IsFavourite }),
      async () => {
        // Send IsFavourite value as the second parameter of the API call
        await api_UpdateIsFavouriteForMerchant(
          dto_Merchant.MID,
          this.state.IsFavourite,
        );

        // Update storage
        let fav = ENCRYPT_STORAGE.getItem(STORE_FAVOURITE_MERCHANT_LIST);
        let foundIndex = fav.findIndex((item) => item.MID === dto_Merchant.MID);
        if (foundIndex !== -1) {
          fav[foundIndex].isFavourite = this.state.IsFavourite;
          ENCRYPT_STORAGE.setItem(STORE_FAVOURITE_MERCHANT_LIST, fav);
        }
      },
    );
  };
}

export class PromoProductList extends ProductList {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      isz2a: true,
      showSortDropDown: false,
      showDropdown: false,
      selectedCategory: "OFFER",
    };
    this.lastTouchTs = 0;
    this.categoryTouchMoved = false;
    this.categoryTouchStart = null;
  }

  getProductDetailNavigatePage = () => "promo-product-list";

  buildPromoCategoryList = (masterCategories = [], promoProductList = []) => {
    if (!Array.isArray(masterCategories) || masterCategories.length === 0) {
      return [];
    }

    const availableCategoryNames = new Set();

    (Array.isArray(promoProductList) ? promoProductList : []).forEach(
      (section) => {
        const sectionCategoryName = String(section?.Category || "")
          .trim()
          .toUpperCase();
        if (sectionCategoryName) {
          availableCategoryNames.add(sectionCategoryName);
        }

        let sectionProducts = [];
        try {
          sectionProducts = JSON.parse(section?.dtoProductSessionList || "[]");
        } catch (error) {
          sectionProducts = [];
        }

        sectionProducts.forEach((item) => {
          const categoryName = String(
            item?.CA || item?.Category || section?.Category || "",
          )
            .trim()
            .toUpperCase();

          if (categoryName) {
            availableCategoryNames.add(categoryName);
          }
        });
      },
    );

    const filteredCategories = masterCategories.filter((category, index) => {
      if (index === 0) {
        return true;
      }

      return availableCategoryNames.has(
        String(category?.Category || "")
          .trim()
          .toUpperCase(),
      );
    });

    // If the cached promo payload has already been narrowed to a single category,
    // keep the full master list so the horizontal selector remains usable.
    return filteredCategories.length > 1
      ? filteredCategories
      : masterCategories;
  };

  getPromoCategoryEntries = () => {
    if (this.state.CategoryList.length > 0) {
      return this.state.CategoryList;
    }

    return this.buildCategoryListFromProducts(this.state.CateList);
  };

  handleCategoryTouchStart = (event) => {
    if (!event.touches || !event.touches[0]) {
      return;
    }
    this.categoryTouchMoved = false;
    this.categoryTouchStart = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
    };
  };

  handleCategoryTouchMove = (event) => {
    if (!this.categoryTouchStart || !event.touches || !event.touches[0]) {
      return;
    }
    const dx = event.touches[0].clientX - this.categoryTouchStart.x;
    const dy = event.touches[0].clientY - this.categoryTouchStart.y;
    if (Math.hypot(dx, dy) > 8) {
      this.categoryTouchMoved = true;
    }
  };

  setSelectedCategoryLabel = (categoryName = "") => {
    const selectedCat = document.getElementById("SelectedCat");
    if (!selectedCat) {
      return;
    }
    selectedCat.innerText =
      categoryName.length > 20
        ? categoryName.slice(0, 20) + "..."
        : categoryName;
  };

  scrollHorizontalCategoryIntoView = (categoryName = "") => {
    const container = document.getElementById(
      "horizontalCategoryScrollContainer",
    );
    if (!container) return;

    const normalizedCategoryName = String(categoryName).trim().toUpperCase();
    const categoryItems = Array.from(container.children);
    const activeItem = categoryItems.find(
      (item) => item.textContent.trim() === normalizedCategoryName,
    );

    if (!activeItem) {
      return;
    }

    const containerWidth = container.offsetWidth;
    const itemOffset = activeItem.offsetLeft;
    const itemWidth = activeItem.offsetWidth;
    const scrollTo = itemOffset - containerWidth / 2 + itemWidth / 2;

    container.scrollTo({
      left: Math.max(0, scrollTo),
      behavior: "smooth",
    });
  };

  applyPromoCategorySelection = async (cate, offset = 105) => {
    set_dto_MobileAppCategory(cate);
    this.setState({ showDropdown: false });
    dto_selected_merchant_or_product.CATID = cate.CATID;

    if (cate.CATID === 0) {
      this.setState({ PrdList: [] });
      localStorage.setItem("isAllCat", true);
      let firstCATID = this.state.CategoryList[1].CATID;
      dto_selected_merchant_or_product.CATID = firstCATID;
      this.setState({ PrdList: [] });
    } else {
      localStorage.setItem("isAllCat", false);
      this.setState({ PrdList: [] });
    }

    await this.loadSubProduct(cate.Category);
    await this.waitForNextPaint();
    this.setSelectedCategoryLabel(cate.Category);
    this.scrollHorizontalCategoryIntoView(cate.Category);
    this.scrollToCategorySection(cate.CATID, cate.Category, offset);
    this.setState({ isLoading: false, selectedCategory: cate.Category });
  };

  handleCategorySelect = async (event, cate, i) => {
    if (event && event.type === "touchend") {
      this.categoryTouchStart = null;
      if (this.categoryTouchMoved) {
        return;
      }
      this.lastTouchTs = Date.now();
      event.preventDefault();
    } else if (Date.now() - this.lastTouchTs < 500) {
      return;
    }

    await this.applyPromoCategorySelection(cate, 105);
  };

  async componentDidMount() {
    if (this.shouldListenToCartUpdates()) {
      window.addEventListener("cartUpdated", this.syncLocalCart);
    }
    const overlay = document.querySelector(".shadow-overlay");
    if (overlay) {
      overlay.style.display = "none";
    }
    if (CSP === "MK") {
      this.setState({ SwitchCategory: false });
      localStorage.setItem("isAllCat", false);
    }
    if (CSP === "DT") {
      if (dto_selected_merchant_or_product.Merchant === "MKB Supermarket") {
        localStorage.setItem("isAllCat", false);
      } else {
        dto_selected_merchant_or_product.CATID = 0;
      }
    }
    await GET_SET_STORED_DATA();
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: dto_selected_merchant_or_product.Merchant,
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_MASTERCATEGORY);
      },
      HeaderNavigatorMenuDisplay: true,
      FnHeaderNavigatorMenu: () => {
        this.TransformationFillterTextBox();
      },
    });

    await this.LoadProduct();
    await this.LoadMasterCategory();
    await api_DaitonnAnalytical();
    await this.Setdinetype();
    this.setState({ selectedCategory: "OFFER" });

    let cart = await GET_CART();
    if (cart !== undefined) {
      this.setState({ LocalCart: cart });
    }
    if (CSP === "MK" || CSP === "DT") {
      this.keepCheckInterval = setInterval(() => {
        this.keepCheck();
      }, 750);
    }
  }

  async keepCheck() {
    let cart = await GET_CART();
    if (cart !== undefined) {
      this.setState({ LocalCart: cart });
    }
  }

  async componentWillUnmount() {
    if (this.shouldListenToCartUpdates()) {
      window.removeEventListener("cartUpdated", this.syncLocalCart);
    }
    super.componentWillUnmount();
    clearInterval(this.keepCheckInterval);
    const overlay = document.querySelector(".shadow-overlay");
    if (overlay) {
      overlay.style.display = "none";
    }
  }

  async Setdinetype() {
    const storedDineType = ENCRYPT_STORAGE.getItem(STORE_DineType);
    let dataStorage = ENCRYPT_STORAGE.getItem(STORE_PROMO_PRODUCT_LIST);
    const MerchantDetails =
      dataStorage?.MerchantData ||
      this.state.MerchantData ||
      dto_selected_final_merchant_or_product ||
      dto_selected_merchant_or_product;

    if (
      MerchantDetails === undefined ||
      MerchantDetails === null ||
      Number.isNaN(Number(MerchantDetails?.MID))
    ) {
      return;
    }

    const resolvedSelection = resolveDineTypeSelection({
      availableDineType: MerchantDetails.DineType,
      storedDineType,
    });

    dto_common.DineType = resolvedSelection.selectedDineType;
    if (dto_selected_final_merchant_or_product.MID === MerchantDetails.MID) {
      SET_STORE_DINE_TYPE(resolvedSelection.selectedDineType);
    }
    this.setState({
      ActiveIndex: resolvedSelection.activeIndex,
      deliveryDisabled: resolvedSelection.deliveryDisabled,
      takeawayDisabled: resolvedSelection.takeawayDisabled,
    });
  }

  sortProducts = (sortType) => {
    let ProductListt = this.state.CateList;
    let PromoProductList = ProductListt[0];
    let PrdList = JSON.parse(PromoProductList.dtoProductSessionList);

    switch (sortType) {
      case "A_TO_Z":
        PrdList.sort((a, b) => {
          const nameA = a.D?.toLowerCase() || "";
          const nameB = b.D?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });
        break;

      case "Z_TO_A":
        PrdList.sort((a, b) => {
          const nameA = a.D?.toLowerCase() || "";
          const nameB = b.D?.toLowerCase() || "";
          return nameB.localeCompare(nameA);
        });
        break;

      case "PRICE_LOW_TO_HIGH":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const priceB = parseFloat(b.P) || 0;
          return priceA - priceB;
        });
        break;

      case "PRICE_HIGH_TO_LOW":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const priceB = parseFloat(b.P) || 0;
          return priceB - priceA;
        });
        break;

      case "DISCOUNT_LOW_TO_HIGH":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const discountPriceA = parseFloat(a.UD) || 0;
          const priceB = parseFloat(b.P) || 0;
          const discountPriceB = parseFloat(b.UD) || 0;

          // Calculate discount percentage
          const discountPercentA =
            priceA > 0 ? ((priceA - discountPriceA) / priceA) * 100 : 0;
          const discountPercentB =
            priceB > 0 ? ((priceB - discountPriceB) / priceB) * 100 : 0;

          return discountPercentA - discountPercentB;
        });
        break;

      case "DISCOUNT_HIGH_TO_LOW":
        PrdList.sort((a, b) => {
          const priceA = parseFloat(a.P) || 0;
          const discountPriceA = parseFloat(a.UD) || 0;
          const priceB = parseFloat(b.P) || 0;
          const discountPriceB = parseFloat(b.UD) || 0;

          // Calculate discount percentage
          const discountPercentA =
            priceA > 0 ? ((priceA - discountPriceA) / priceA) * 100 : 0;
          const discountPercentB =
            priceB > 0 ? ((priceB - discountPriceB) / priceB) * 100 : 0;

          return discountPercentB - discountPercentA;
        });
        break;

      default:
        break;
    }

    PromoProductList.dtoProductSessionList = JSON.stringify(PrdList);
    ProductListt[0] = PromoProductList;
    this.setState({ CateList: ProductListt, showSortDropDown: false });

    if (isMobile) {
      $("html,body").animate({ scrollTop: 10 }, 700);
    } else {
      $(".WindowDevice").animate({ scrollTop: 10 }, 700);
    }
  };

  async TransformationFillterTextBox() {
    var element = document.getElementsByClassName("transform");
    element[0].classList.add("transform-active-fillter-product");
    $(".productlistFilterTextBox").fadeIn(1000);
    // $("#InputproductlistFilterTextBox").focus();

    let overlay = document.querySelector(".shadow-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "shadow-overlay";
      document.body.appendChild(overlay);
    }

    const headerHeight = document.getElementById("DivHeaderHome").offsetHeight;
    overlay.style.top = `${headerHeight}px`;

    overlay.style.width = isMobile ? "100%" : `${WebWidth}px`;
    overlay.style.left = isMobile ? 0 : WebLeft;

    overlay.style.display = "block";
    overlay.addEventListener("click", () => {
      $(".productlistFilterTextBox").fadeOut(800);
      element[0].classList.remove("transform-active-fillter-product");
      this.setState({
        PrdList: this.state.inMemoryProducts,
        CateList: this.state.inMemoryProducts,
        displayMessage: false,
      });
      overlay.style.display = "none";
    });

    FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS({
      FnFilterTextBox: (e) => {
        this.InputproductlistFilterTextBoxOnChange(e);
      },
      FnFilterCloseButton: (e) => {
        if (element) {
          element[0].classList.remove("transform-active-fillter-product");
          $(".productlistFilterTextBox").fadeOut(800);
          this.setState({
            PrdList: this.state.inMemoryProducts,
            CateList: this.state.inMemoryProducts,
            displayMessage: false,
          });
          overlay.style.display = "none";
        }
      },
      FnFilterClearButton: (e) => {
        this.setState((state) => {
          const PrdList = [...this.state.inMemoryProducts];
          const CateList = [...this.state.inMemoryProducts];
          const displayMessage = false;
          return {
            PrdList,
            CateList,
            displayMessage,
          };
        });
      },
    });
  }

  async LoadMasterCategory() {
    let catdata = await api_CategoryPageLoadGroceryCategory();
    let catobjData = JSON.parse(catdata);

    let data = ENCRYPT_STORAGE.getItem(STORE_PROMO_PRODUCT_LIST);
    let promoProductList = Array.isArray(data?.PromoProductList)
      ? data.PromoProductList
      : [];

    await this.setStateAsync({
      CategoryList: this.buildPromoCategoryList(catobjData, promoProductList),
    });
  }

  async LoadApiProduct() {
    let data = await api_LoadProductListToMobileAppForAnMID();
    let ObjData = JSON.parse(data);
    let PromoProductList = ObjData[0];
    let ProductListt;
    if (
      (CSP === "MK" && dto_selected_merchant_or_product.CATID !== 1) ||
      (CSP === "DT" &&
        dto_selected_merchant_or_product.Merchant === "MKB Supermarket" &&
        dto_selected_merchant_or_product.CATID !== 1)
    ) {
      let withoutOffer = PromoProductList.filter(
        (item) => item.Category !== "OFFER",
      );
      ProductListt = withoutOffer;
    } else {
      ProductListt = PromoProductList;
    }
    let MerchantDataa = ObjData[1];
    this.setState({ MerchantData: MerchantDataa });
    ENCRYPT_STORAGE.removeItem(STORE_PROMO_PRODUCT_LIST);
    ENCRYPT_STORAGE.setItem(STORE_PROMO_PRODUCT_LIST, {
      PromoProductList: ProductListt,
      MID: MerchantDataa.MID,
      MerchantData: MerchantDataa,
      date: new Date(),
      CATID: dto_selected_merchant_or_product.CATID,
    });
    return ProductListt;
  }

  async LoadProduct() {
    try {
      this.setState({ isLoading: true });
      let dataStorage = ENCRYPT_STORAGE.getItem(STORE_PROMO_PRODUCT_LIST);
      let data = "";
      if (dataStorage !== undefined && dataStorage !== "") {
        if (dataStorage.MID === dto_selected_merchant_or_product.MID) {
          let StorageDateTime = new Date(dataStorage.date);
          let currentDateTime = new Date();
          let DifferenceMinute = DIFERENCE_MINUTES(
            currentDateTime,
            StorageDateTime,
          );
          if (DifferenceMinute > 1) {
            ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
            data = await this.LoadApiProduct();
          } else {
            if (
              dto_selected_merchant_or_product.MT === "GR" ||
              dto_selected_merchant_or_product.MT === "AF" ||
              CSP === "MK"
            ) {
              if (
                dataStorage.CATID === dto_selected_merchant_or_product.CATID
              ) {
                data = dataStorage.PromoProductList;
                this.setState({ MerchantData: dataStorage.MerchantData });
              } else {
                ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                data = await this.LoadApiProduct();
              }
            } else {
              data = dataStorage.PromoProductList;
              this.setState({ MerchantData: dataStorage.MerchantData });
            }
          }
        } else {
          ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
          data = await this.LoadApiProduct();
        }
      } else {
        ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
        data = await this.LoadApiProduct();
      }

      let Localcart = await GET_CART();
      if (Localcart === undefined) {
        Localcart = [];
      }

      this.setState(
        {
          CateList: data,
          PrdList: data,
          inMemoryProducts: data,
          isLoading: false,
          LocalCart: Localcart,
        },
        () => {},
      );

      setTimeout(async () => {
        if (!this.state.isLoading) {
          await this.ScrollIndicaterMenu();
        }
      }, 500);

      setTimeout(() => {
        let PID = ENCRYPT_STORAGE_SESSION.getItem("PrdIdScroll");
        if (PID !== undefined) {
          if (isMobile) {
            $("html,body").animate(
              {
                scrollTop: $("#" + PID)[0].offsetTop - 110,
              },
              500,
            );
          } else {
            $(".WindowDevice").animate(
              {
                scrollTop: $("#" + PID)[0].offsetTop - 110,
              },
              500,
            );
          }
        } else {
          if (isMobile) {
            $("html,body").animate(
              {
                scrollTop: 10,
              },
              0,
            );
          } else {
            $(".WindowDevice").animate(
              {
                scrollTop: 10,
              },
              0,
            );
          }
        }
      }, 100);
      setTimeout(() => {
        let cateSection = document.getElementById("cateSection");
        if (cateSection) {
          cateSection.style.display = CSP === "MK" ? "block" : "none";
        }
      }, 50);
    } catch (error) {
      console.error("LoadProductList : " + error);
      if (error?.isInvalidQrMerchant) {
        ENCRYPT_STORAGE.setItem(STORE_INVALID_QR, true);
        this.setState({
          invalidQr: true,
          displayMessage: true,
          isLoading: false,
          CateList: [],
          PrdList: [],
          inMemoryProducts: [],
        });
        return;
      }
      if (error?.isApiRecoveryRedirect) {
        this.setState({ isLoading: false });
        return;
      }
    }
  }

  async loadSubProduct(SelectedCat) {
    try {
      this.setState({ isLoading: true, selectedCategory: SelectedCat });

      dto_selected_merchant_or_product.CATID = 1;
      let prdlist = await this.LoadApiProduct();
      let objPrdList = JSON.parse(prdlist[0].dtoProductSessionList);
      let filteredList = objPrdList;
      if (SelectedCat !== "OFFER") {
        filteredList = objPrdList.filter((item) => item.CA === SelectedCat);
      }
      let data = JSON.stringify(filteredList);
      prdlist[0].dtoProductSessionList = data;

      this.setState({
        PrdList: prdlist,
        isLoading: false,
      });
    } catch (error) {
      console.error("Error loading sub-products:", error);
    }
  }

  async ScrollIndicaterMenu() {
    let ItemSection = document.getElementsByClassName("ItemList");
    let CateSection = document.getElementsByClassName("btnCategorys");

    let element;
    if (isMobile) {
      element = document.querySelector(".body-container");
    } else {
      element = document.querySelector(".WindowDevice");
    }

    // Initial scroll to show the selected category on page load
    setTimeout(() => {
      const currentSelectedCategory = this.state.selectedCategory;
      if (currentSelectedCategory) {
        this.scrollHorizontalCategoryIntoView(currentSelectedCategory);
      }
    }, 200);

    element.removeEventListener("scroll", this.handleScroll);
    this.handleScroll = async () => {
      const cateSection = document.getElementById("cateSection");
      if (cateSection) {
        cateSection.style.display = "block";
      }

      for (let i = 0; i < ItemSection.length; i++) {
        let top = element.scrollTop;
        let offset = ItemSection[i].offsetTop - 120;
        let Height = ItemSection[i].offsetHeight;
        let ID = ItemSection[i].id;
        let ScrollToTopBTN = document.getElementById("ScrollToTopBTN");

        if (top > 1630) {
          ScrollToTopBTN.style.display = "none";
        } else {
          ScrollToTopBTN.style.display = "none";
        }

        if (top >= offset && top < offset + Height) {
          if (CSP === "MK" || CSP === "DT") {
            let x = document.getElementById(ID);
            let CategoryName = x.querySelector("h1").innerText;
            const truncatedText =
              CategoryName.length > 20
                ? CategoryName.slice(0, 20) + "..."
                : CategoryName;

            // Update the selected category text
            this.setSelectedCategoryLabel(truncatedText);

            // Auto-scroll the horizontal category list to show the active category
            this.scrollHorizontalCategoryIntoView(CategoryName);

            // Update the selectedCategory state
            this.setState({ selectedCategory: CategoryName });

            if (
              CSP === "MK" ||
              (CSP === "DT" &&
                dto_selected_merchant_or_product.Merchant === "MKB Supermarket")
            ) {
              let SelectedCATID = dto_selected_merchant_or_product.CATID;
              const isScrolledToBottom =
                element.scrollTop + element.clientHeight >=
                element.scrollHeight;
              let CategoryList = this.state.CategoryList;
              let isAllCat = localStorage.getItem("isAllCat");

              if (isScrolledToBottom && isAllCat === "true") {
                if (CategoryList && CategoryList.length > 0) {
                  const index = CategoryList.findIndex(
                    (item) => item.CATID === SelectedCATID,
                  );

                  if (index !== -1 && index < CategoryList.length - 1) {
                    const nextCATID = CategoryList[index + 1].CATID;
                    SelectedCATID = dto_selected_merchant_or_product.CATID =
                      nextCATID;

                    const nextCategory = CategoryList[index + 1];
                    await this.loadSubProduct(nextCategory.Category);
                  }
                }
              }
            }
          }

          for (let c = 0; c < CateSection.length; c++) {
            if (CateSection[c].classList[0] === ID) {
              CateSection[c].style.color = "white";
              CateSection[c].style.backgroundColor = Colors.DarkGreyScale;

              var scrollTo = CateSection[c].offsetLeft;
              var xd = $("#cateSection");
              xd[0].scrollLeft = scrollTo - 3;
            } else {
              CateSection[c].style.color = "black";
              CateSection[c].style.backgroundColor = Colors.LightGreyScale;
            }
          }
        }
      }
    };
    element.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  }

  handleFilterChange = (e) => {
    const filterText = e.target.value;
    this.setState({ filterText });
    this.filterProductList(filterText.toLowerCase());

    const overlay = document.querySelector(".shadow-overlay");
    if (overlay) {
      overlay.style.display = "none";
    }
  };

  showOverlay = () => {
    let overlay = document.querySelector(".shadow-overlay");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "shadow-overlay";
      document.body.appendChild(overlay);
    }

    overlay.style.top = "45px";
    overlay.style.width = isMobile ? "100%" : `${WebWidth}px`;
    overlay.style.left = isMobile ? 0 : WebLeft;
    overlay.style.position = "fixed";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "rgba(0,0,0,0.5)";
    overlay.style.zIndex = "1000";
    overlay.style.display = "block";

    overlay.onclick = () => {
      $("#NewFilterationTextBox").fadeOut(500);
      overlay.style.display = "none";
      this.resetFilter();
    };
  };

  filterProductList = (filterText) => {
    const filteredCateList = this.state.inMemoryProducts
      .map((category) => {
        const filteredProducts = JSON.parse(
          category.dtoProductSessionList,
        ).filter((product) => product.D.toLowerCase().includes(filterText));
        return {
          ...category,
          dtoProductSessionList: JSON.stringify(filteredProducts),
        };
      })
      .filter(
        (category) => JSON.parse(category.dtoProductSessionList).length > 0,
      );

    this.setState({
      CateList: filteredCateList,
      PrdList: filteredCateList,
      displayMessage: filteredCateList.length === 0,
    });
  };

  resetFilter = () => {
    this.setState({
      CateList: this.state.inMemoryProducts,
      PrdList: this.state.inMemoryProducts,
      displayMessage: false,
      filterText: "",
    });
  };

  handleCancelClick = () => {
    $("#NewFilterationTextBox").animate(
      {
        height: "toggle",
      },
      500,
      () => {
        this.resetFilter();
        const overlay = document.querySelector(".shadow-overlay");
        if (overlay) {
          overlay.style.display = "none";
        }
        $("#NewFilterationTextBox").hide();
      },
    );
  };

  InputproductlistFilterTextBoxOnChange(e) {
    let item = [];
    let IsFiltered = false;
    let TempItems = cloneDeep(this.state.inMemoryProducts);
    TempItems.forEach((rs) => {
      // Changed from map to forEach
      let lIstArrayPrd = [];
      // let products = JSON.parse(rs.dtoProSesL);
      let products = JSON.parse(rs.dtoProductSessionList);

      products.filter((prd) => {
        let isMatch = prd.D.toLowerCase().includes(
          e.currentTarget.value.toLowerCase(),
        );
        if (isMatch) {
          IsFiltered = true;
          lIstArrayPrd.push(prd);
        }
        return isMatch; // Explicitly return a boolean value
      });

      // rs.dtoProSesL = JSON.stringify(lIstArrayPrd);
      rs.dtoProductSessionList = JSON.stringify(lIstArrayPrd);
      item.push(rs);
    });
    if (IsFiltered) {
      this.setState({
        PrdList: item,
        CateList: item,
        displayMessage: false,
      });
    } else {
      this.setState({
        PrdList: item,
        CateList: item,
        displayMessage: true,
      });
    }
  }

  render() {
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);

    if (this.state.invalidQr) {
      return (
        <div
          id="OnScrollProdcutList"
          style={{
            marginBottom: 55,
            marginTop: "44px",
          }}
        >
          {this.renderNoMatchState("80px")}
        </div>
      );
    }

    const promoCategoryEntries = this.getPromoCategoryEntries();
    const showPromoStickyCategory =
      CSP !== "MK" && promoCategoryEntries.length > 0;

    return (
      <div
        id="OnScrollProdcutList"
        style={{
          marginBottom: 55,
          marginTop:
            CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
              ? "44px"
              : this.state.MainTopMargin,
        }}
      >
        <div
          id="NewFilterationTextBox"
          className="fadeInBottom cssanimation"
          style={{
            display: "none",
            position: "absolute",
            paddingTop: "5px",
            top: 0,
            height: 50,
            width: "100%",
            zIndex: 1800,
            backgroundColor: "white",
          }}
        >
          <div style={{ display: "flex" }}>
            {/* textbox */}
            <input
              className="productlistFilterTextBox"
              type="text"
              style={{
                width: "90%",
                height: 50,
                border: "none",
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                paddingLeft: "8px",
              }}
              value={this.state.filterText}
              placeholder="Filter Items"
              id="InputproductlistFilterTextBox"
              onChange={this.handleFilterChange}
            />

            {/* circle close */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderRight: "1px solid gray",
                color: "#a1a1a1",
                backgroundColor: "#fff",
                padding: "7px",
              }}
              id="btnproductlistFilterTextBoxclear"
              onClick={this.resetFilter}
            >
              <i className="bi bi-x-circle-fill" />
            </button>

            {/* cancel */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                backgroundColor: "white",
                fontFamily: F_Fammily.Medium,
                fontWeight: "600",
              }}
              id="btnproductlistFilterTextBoxClsoe"
              onClick={this.handleCancelClick}
            >
              Cancel
            </button>
          </div>
        </div>

        {this.state.isLoading ? (
          <PlaceHolder />
        ) : (
          <>
            <div
              style={{
                display:
                  CSP === "MK" || dto_selected_merchant_or_product.MT === "AF"
                    ? "none"
                    : "block",
              }}
            >
              {/* Parent div with relative positioning */}
              <div style={{ position: "relative" }}>
                <img
                  src={this.state.MerchantData.IL}
                  style={{ width: "100%", height: 180, objectFit: "cover" }}
                  alt={this.state.MerchantData.IL}
                />

                {/* Back Icon */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "5px",
                    fontSize: 24,
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    padding: "5px",
                    borderRadius: "30px",
                    display: this.state.iconDisplay,
                  }}
                  onClick={() => {
                    if (dto_selected_merchant_or_product.MT === "RS") {
                      if (this.props.params.navPage === "home-filter") {
                        this.props.navigate(
                          PT_FILTER_OUTLETS_PRODUCTS.replace(
                            ":frmpath",
                            "home",
                          ),
                        );
                      } else {
                        this.props.navigate(PT_HOME);
                      }
                    } else {
                      this.props.navigate(PT_MASTERCATEGORY);
                    }
                  }}
                >
                  <i className="bi bi-arrow-left" />
                </div>

                {/* Search Icon */}
                <div
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    top: "10px",
                    right: "5px",
                    fontSize: 24,
                    color: "white",
                    padding: "5px",
                    borderRadius: "30px",
                    display: this.state.iconDisplay,
                  }}
                  id="HeaderNavigatorBoostrapIcon"
                  onClick={() => {
                    $("#NewFilterationTextBox").fadeIn(500);
                    this.showOverlay();
                  }}
                >
                  <i className="bi bi-search" />
                </div>
              </div>

              {/* Merchant Info Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 5px",
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    display: CSP === "DT" || CSP === "MK" ? "none" : "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-shop" style={{ paddingRight: "8px" }} />
                  {this.state.MerchantData.Merchant}
                </div>

                <div
                  style={{
                    display: this.state.MerchantData.AR > 0 ? "flex" : "none",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-hand-thumbs-up-fill" />
                  <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                    {" "}
                    {this.state.MerchantData.AR}%
                  </span>
                </div>
              </div>
            </div>

            {this.state.CateList.length !== 0 ? (
              <div>
                {showPromoStickyCategory ? (
                  <div
                    style={{
                      backgroundColor: "white",
                      position: "fixed",
                      left: isMobile ? 0 : WebLeft,
                      width: isMobile ? "100%" : WebWidth,
                      right: 0,
                      zIndex: 1500,
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      overflowY: "hidden",
                      padding: 5,
                      top: 48,
                      display: "block",
                    }}
                    id="cateSection"
                  >
                    <div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "10% 75% 15%",
                          alignItems: "center",
                        }}
                      >
                        <i
                          className="bi bi-list"
                          style={{
                            fontSize: 18,
                            borderRadius: "18px",
                            marginLeft: "6px",
                            marginRight: "6px",
                            color: "white",
                            padding: "3px 4px",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            justifySelf: "start",
                          }}
                          onClick={() =>
                            this.setState({
                              showDropdown: !this.state.showDropdown,
                            })
                          }
                        />

                        <h1
                          id="SelectedCat"
                          style={{
                            fontSize: 21,
                            fontFamily: F_Fammily.Medium,
                            margin: 0,
                            fontWeight: "bold",
                            wordWrap: "break-word",
                            color: "black",
                            padding: "5px",
                            textAlign: "center",
                          }}
                        />

                        <i
                          className="bi bi-funnel"
                          style={{
                            fontSize: 18,
                            borderRadius: "18px",
                            marginLeft: "6px",
                            marginRight: "6px",
                            color: "white",
                            padding: "3px 4px",
                            backgroundColor: "rgba(0, 0, 0, 0.8)",
                            justifySelf: "end",
                          }}
                          onClick={() =>
                            this.setState({
                              showSortDropDown: true,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                ) : null}

                <div
                  className="container"
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: showPromoStickyCategory ? 48 : 0,
                  }}
                >
                  <div>
                    {this.state.PrdList.map &&
                      this.state.PrdList.map((cate, i) => {
                        let PrdList = [];
                        PrdList = JSON.parse(cate.dtoProductSessionList);
                        if (PrdList.length > 0) {
                          return (
                            <div
                              className="ItemList"
                              id={cate.CATID + "SECTIONS"}
                              key={cate.CATID + "PromoProductList" + i + "Key"}
                            >
                              <div
                                className="row"
                                key={cate.CATID + i + "Key"}
                                style={{ display: "block" }}
                              >
                                <Category
                                  Category={cate.Category.toUpperCase()}
                                  ID={cate.CATID}
                                  key={
                                    cate.CATID + "CategoryHeading" + i + "Key"
                                  }
                                />
                              </div>
                              <div className="" key={i + cate.CATID + "PRD"}>
                                {PrdList.map((item, i) => {
                                  return (
                                    <React.Fragment
                                      key={
                                        item.PI + "PromoProductListFragment" + i
                                      }
                                    >
                                      <ItemView
                                        onCartUpdated={(updatedCart) => {
                                          this.setState({
                                            LocalCart: updatedCart || [],
                                          });
                                        }}
                                        onClick={async (rs, index) => {
                                          await Api_DrawAnalyticalPath(1, rs);
                                          ENCRYPT_STORAGE_SESSION.setItem(
                                            "PrdIdScroll",
                                            rs + "PRD" + index,
                                          );

                                          // Always allow navigation to product detail when clicking the item (including when W is true)
                                          this.props.navigate(
                                            PT_PRODUCT.replace(
                                              ":frompage",
                                              "product-list",
                                            )
                                              .replace(
                                                ":navigatepage",
                                                this.getProductDetailNavigatePage(),
                                              )
                                              .replace(
                                                ":category",
                                                cate.Category.replace(
                                                  "/",
                                                  "-",
                                                ).toLowerCase(),
                                              )
                                              .replace(":pid", rs)
                                              .replace(":lineid", 1)
                                              .replace(":adonlineid", 1)
                                              .replace(":isrecommended", 0),
                                          );
                                        }}
                                        goToProduct={(rs) => {
                                          this.props.navigate(
                                            PT_PRODUCT.replace(
                                              ":frompage",
                                              "product-list",
                                            )
                                              .replace(
                                                ":navigatepage",
                                                this.getProductDetailNavigatePage(),
                                              )
                                              .replace(
                                                ":category",
                                                cate.Category.replace(
                                                  "/",
                                                  "-",
                                                ).toLowerCase(),
                                              )
                                              .replace(":pid", rs.PI)
                                              .replace(":lineid", 1)
                                              .replace(":adonlineid", 1)
                                              .replace(":isrecommended", 0),
                                          );
                                        }}
                                        key={item.PI + "PromoProductList" + i}
                                        pid={item.PI}
                                        data={item}
                                        index={i}
                                        Description={item.D}
                                        GenDesc={item.G}
                                        SP={item.P}
                                        UD={item.UD}
                                        IsAvailable={item.A}
                                        ProductImage={
                                          <div className="">
                                            {item.IU !== "" &&
                                            item.IU !== "N/A" ? (
                                              <img
                                                style={{
                                                  height: 70,
                                                  width: 70,
                                                  padding: 0,
                                                  borderRadius: 10,
                                                }}
                                                loading="lazy"
                                                id={"prdImageLise" + item.PI}
                                                src={item.IU.split("λ")[0]}
                                                alt=""
                                                onError={(e) => {
                                                  e.currentTarget.src =
                                                    dto_common.DefaultImageUrl;
                                                }}
                                              />
                                            ) : (
                                              <img
                                                style={{
                                                  height: 30,
                                                  width: 30,
                                                  padding: 0,
                                                  borderRadius: 10,
                                                  filter: "grayscale(100%)",
                                                  WebkitFilter:
                                                    "grayscale(100%)",
                                                }}
                                                src={dto_common.DefaultImageUrl}
                                                onError={(e) => {
                                                  e.currentTarget.src =
                                                    dto_common.DefaultImageUrl;
                                                }}
                                                alt=""
                                              />
                                            )}
                                          </div>
                                        }
                                      />
                                      <div
                                        style={{
                                          borderTop: "1px solid black",
                                          transform: "scaleY(0.1)",
                                          display: "block",
                                        }}
                                      />
                                    </React.Fragment>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}
                  </div>

                  {this.state.displayMessage
                    ? this.renderNoMatchState("200px")
                    : null}
                  {!this.state.displayMessage && CSP === "MK" ? (
                    <div
                      style={{
                        backgroundColor: Colors.DarkGreyScale,
                        borderRadius: "4px",
                        color: "white",
                        display: CSP === "MK" ? "block" : "none",
                        margin: "24px auto 0",
                        padding: "4px 8px",
                        textAlign: "center",
                        width: "fit-content",
                      }}
                      onClick={() => {
                        this.props.navigate(
                          PT_FILTER_OUTLETS_PRODUCTS.replace(
                            ":frmpath",
                            "category",
                          ),
                        );
                        let filterText = document.getElementById(
                          "InputproductlistFilterTextBox",
                        ).value;
                        ENCRYPT_STORAGE.setItem(
                          "SearchStringFilter",
                          filterText,
                        );
                      }}
                    >
                      Find More
                    </div>
                  ) : null}
                </div>

                {dto_selected_merchant_or_product.MT !== "RS" ? (
                  <button
                    id="CategoryBTN"
                    style={{
                      left: isMobile ? "80%" : "63%",
                    }}
                    onClick={() => {
                      $("#DisplayCateList").show(400);
                    }}
                  >
                    <i className="bi bi-list" style={{ fontSize: 28 }} />
                  </button>
                ) : (
                  ""
                )}

                {!this.state.displayMessage ? (
                  <button
                    id="ScrollToTopBTN"
                    title="Go to top"
                    style={{ left: isMobile ? "80%" : "63%" }}
                    onClick={() => {
                      if (isMobile) {
                        $("html,body").animate(
                          {
                            scrollTop: 10,
                          },
                          700,
                        );
                      } else {
                        $(".WindowDevice").animate(
                          {
                            scrollTop: 10,
                          },
                          700,
                        );
                      }
                    }}
                  >
                    <i
                      className="bi bi-arrow-up-square"
                      style={{ fontSize: 28 }}
                    />
                  </button>
                ) : null}

                {/* View Basket For View Cart */}
                {this.state.LocalCart.length > 0
                  ? this.renderFloatingQuickCartButton(
                      entryMode === "QR" &&
                        (dto_Customer.CSID === 0 ||
                          dto_Customer.CSID === undefined)
                        ? "10px"
                        : "52px",
                    )
                  : null}

                {/* View Basket For View Cart */}
                {/* {this.state.LocalCart.length > 0 && dto_selected_merchant_or_product.MT === "GR" &&
                (CSP === "MK" || CSP === "DT") ? (
                  <button
                    id="QuickCartBTN"
                    style={{
                      position: "fixed",
                      backgroundColor: "rgb(83, 78, 78)",
                      bottom: "52px",
                      zIndex: 99,
                      padding: "12px 15px",
                      border: "none",
                      outline: "none",
                      borderRadius: "8px",
                      fontSize: 16,
                      color: "white",
                      left: "50%",
                      transform: "translateX(-50%)",
                      textAlign: "left",
                      whiteSpace: "nowrap",
                      alignItems: "center",
                    }}
                    onClick={async () => {
                      let Localcart = await GET_CART();
                      if (Localcart === undefined) {
                        Localcart = [];
                      }
                      this.setState(
                        { IsSummaryCart: true, LocalCart: Localcart },
                        async () => {
                          await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(
                            async () => {
                              let Localcart = await GET_CART();
                              if (Localcart === undefined) {
                                Localcart = [];
                              }
                              this.setState({
                                IsSummaryCart: false,
                                LocalCart: Localcart,
                              });
                            }
                          );
                        }
                      );
                    }}
                  >
                    <span
                      style={{
                        fontSize: "20px",
                      }}
                    >
                      View basket
                    </span>
                    {" ("}
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {dto_selected_merchant_or_product.MT !== "GR"
                        ? this.state.LocalCart.length
                        : this.getTotalPrice()}
                    </span>
                    {")"}
                  </button>
                ) : null} */}
              </div>
            ) : (
              this.renderNoMatchState("70px")
            )}
          </>
        )}

        {dto_selected_merchant_or_product.MT !== "RS" ? (
          <div
            id="DisplayCateList"
            style={{
              position: "fixed",
              zIndex: 4600,
              left: 0,
              top: 0,
              width: "100%",
              height: "100%",
              overflow: "auto",
              display: "none",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
            onClick={() => {
              $("#DisplayCateList").hide(400);
            }}
          >
            <div
              style={{
                width: 230,
                height: 300,
                position: "fixed",
                zIndex: 3500,
                bottom: 200,
                right: 80,
                backgroundColor: "white",
                padding: 3,
                overflow: "auto",
              }}
            >
              {this.state.CateList.map((rs, i) => {
                if (rs.dtoProductSessionList !== "[]") {
                  return (
                    <div
                      key={rs.CATID + "Modal" + i}
                      style={{ display: "flex" }}
                      onClick={() => {
                        if (isMobile) {
                          $("html,body").animate(
                            {
                              scrollTop: $("#" + rs.CATID)[0].offsetTop - 105,
                            },
                            1000,
                          );
                        } else {
                          $(".WindowDevice").animate(
                            {
                              scrollTop: $("#" + rs.CATID)[0].offsetTop - 105,
                            },
                            1000,
                          );
                        }
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          borderBottom: "0.5px solid #ecf0f1",
                          padding: 5,
                          width: "85%",
                          fontSize: 12,
                        }}
                      >
                        {/* {rs.Cat.toUpperCase()} */}
                        {rs.Category.toUpperCase()}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          width: "15%",
                          padding: 5,
                          paddingLeft: 10,
                        }}
                      >
                        <i className="bi bi-arrow-right-circle" />
                      </p>
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </div>
          </div>
        ) : (
          ""
        )}

        <DrawerSheetBottom
          open={this.state.showDropdown}
          closeFunction={() => this.setState({ showDropdown: false })}
          displayCloseIcon="block"
          element={
            <div style={{ position: "relative", height: "100%" }}>
              <div
                style={{
                  maxHeight: "calc(100% - 70px)",
                  overflowY: "auto",
                }}
              >
                {this.state.CategoryList.map((cate, i) => {
                  return (
                    <div
                      key={"dropdownKey" + i + cate.CATID}
                      style={{
                        padding: "12px 12px",
                        cursor: "pointer",
                        fontSize: "16px",
                        borderBottom: "1px solid #eee",
                      }}
                      onClick={async () => {
                        await this.applyPromoCategorySelection(cate, 105);
                      }}
                    >
                      {cate.Category.toUpperCase()}
                    </div>
                  );
                })}
              </div>

              <button
                style={{
                  position: "absolute",
                  bottom: 10,
                  cursor: "pointer",
                  width: "100%",
                  height: "48px",
                  background: Colors.DarkGreyScale,
                  fontFamily: F_Fammily.Medium,
                  color: Colors.FontColor,
                  borderRadius: "8px",
                  marginTop: 6,
                  border: "none",
                  fontSize: "20px",
                }}
                onClick={() => this.setState({ showDropdown: false })}
              >
                {" "}
                DISMISS{" "}
              </button>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Categories"
        />

        <DrawerSheetBottom
          open={this.state.showDropdown}
          closeFunction={() => this.setState({ showDropdown: false })}
          displayCloseIcon="block"
          element={
            <div style={{ position: "relative", height: "100%" }}>
              <div
                style={{
                  maxHeight: "calc(100% - 70px)",
                  overflowY: "auto",
                }}
              >
                {this.state.CategoryList.map((cate, i) => {
                  return (
                    <div
                      key={"dropdownKey" + i + cate.CATID}
                      style={{
                        padding: "12px 12px",
                        cursor: "pointer",
                        fontSize: "16px",
                        borderBottom: "1px solid #eee",
                      }}
                      onClick={async () => {
                        await this.applyPromoCategorySelection(cate, 105);
                      }}
                    >
                      {cate.Category.toUpperCase()}
                    </div>
                  );
                })}
              </div>

              <button
                style={{
                  position: "absolute",
                  bottom: 10,
                  cursor: "pointer",
                  width: "100%",
                  height: "48px",
                  background: Colors.DarkGreyScale,
                  fontFamily: F_Fammily.Medium,
                  color: Colors.FontColor,
                  borderRadius: "8px",
                  marginTop: 6,
                  border: "none",
                  fontSize: "20px",
                }}
                onClick={() => this.setState({ showDropdown: false })}
              >
                {" "}
                DISMISS{" "}
              </button>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Categories"
        />

        <DrawerSheetBottom
          open={this.state.IsSummaryCart}
          closeFunction={() => this.setState({ IsSummaryCart: false })}
          element={
            <SummaryCart
              CartData={this.state.LocalCart}
              navigate={this.props.navigate}
              ItemClick={async (item) => {
                this.setState({ IsSummaryCart: false }, () => {
                  this.props.navigate(
                    PT_PRODUCT.replace(":frompage", "cart")
                      .replace(":navigatepage", "promo-product-list")
                      .replace(":category", "category")
                      .replace(":pid", item.PID)
                      .replace(":lineid", item.LineID)
                      .replace(":adonlineid", item.ADDONLINEID)
                      .replace(":isrecommended", 0),
                  );
                });
              }}
              onCartUpdated={(updatedCart) => {
                this.setState({ LocalCart: updatedCart });
              }}
              closeFunction={() => this.setState({ IsSummaryCart: false })}
            />
          }
          size={isMobile ? "85%" : 280}
          Heading="Shopping List"
        />

        <DrawerSheetBottom
          open={this.state.showSortDropDown}
          closeFunction={() => this.setState({ showSortDropDown: false })}
          element={
            <div>
              {/* A-Z */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("A_TO_Z")}
              >
                <i
                  className="bi bi-sort-alpha-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Sort A - Z
                </span>
              </div>
              <br />

              {/* Z-A */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("Z_TO_A")}
              >
                <i
                  className="bi bi-sort-alpha-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Sort Z - A
                </span>
              </div>
              <br />

              {/* Price Low to High */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("PRICE_LOW_TO_HIGH")}
              >
                <i
                  className="bi bi-sort-numeric-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Price low to high
                </span>
              </div>
              <br />

              {/* Price High to Low */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("PRICE_HIGH_TO_LOW")}
              >
                <i
                  className="bi bi-sort-numeric-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Price high to low
                </span>
              </div>
              <br />

              {/* Discount Low to High */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("DISCOUNT_LOW_TO_HIGH")}
              >
                <i
                  className="bi bi-sort-down-alt"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Discounts % low to high
                </span>
              </div>
              <br />

              {/* Discount High to Low */}
              <div
                style={{ borderBottom: "1px solid black" }}
                onClick={() => this.sortProducts("DISCOUNT_HIGH_TO_LOW")}
              >
                <i
                  className="bi bi-sort-down"
                  style={{
                    marginRight: "10px",
                    fontSize: 30,
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                />
                <span style={{ fontSize: 18, fontWeight: "bold" }}>
                  Discounts % high to low
                </span>
              </div>
            </div>
          }
          size={isMobile ? "85%" : 280}
          Heading="Sort Products"
        />
      </div>
    );
  }
}
